var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPepperoni(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 381.6 381.6",
    style: {
      enableBackground: "new 0 0 381.6 381.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.5;fill:url(#SVGID_2_);}\n\t.st2{opacity:0.5;fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{opacity:0.5;fill:#FFFFFF;}\n\t.st6{opacity:0.5;fill:url(#SVGID_5_);}\n\t.st7{opacity:0.5;fill:url(#SVGID_6_);}\n\t.st8{opacity:0.5;fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:url(#SVGID_9_);}\n\t.st11{opacity:0.5;fill:url(#SVGID_10_);}\n\t.st12{opacity:0.5;fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{opacity:0.5;fill:url(#SVGID_13_);}\n\t.st15{opacity:0.5;fill:url(#SVGID_14_);}\n\t.st16{opacity:0.5;fill:url(#SVGID_15_);}\n\t.st17{fill:url(#SVGID_16_);}\n\t.st18{fill:url(#SVGID_17_);}\n\t.st19{opacity:0.5;fill:url(#SVGID_18_);}\n\t.st20{opacity:0.5;fill:url(#SVGID_19_);}\n\t.st21{fill:url(#SVGID_20_);}\n\t.st22{opacity:0.5;fill:url(#SVGID_21_);}\n\t.st23{opacity:0.5;fill:url(#SVGID_22_);}\n\t.st24{opacity:0.5;fill:url(#SVGID_23_);}\n\t.st25{fill:url(#SVGID_24_);}\n\t.st26{fill:url(#SVGID_25_);}\n\t.st27{opacity:0.5;fill:url(#SVGID_26_);}\n\t.st28{opacity:0.5;fill:url(#SVGID_27_);}\n\t.st29{fill:url(#SVGID_28_);}\n\t.st30{opacity:0.5;fill:url(#SVGID_29_);}\n\t.st31{opacity:0.5;fill:url(#SVGID_30_);}\n\t.st32{opacity:0.5;fill:url(#SVGID_31_);}\n\t.st33{fill:url(#SVGID_32_);}\n\t.st34{fill:url(#SVGID_33_);}\n\t.st35{opacity:0.5;fill:url(#SVGID_34_);}\n\t.st36{opacity:0.5;fill:url(#SVGID_35_);}\n\t.st37{fill:url(#SVGID_36_);}\n\t.st38{opacity:0.5;fill:url(#SVGID_37_);}\n\t.st39{opacity:0.5;fill:url(#SVGID_38_);}\n\t.st40{opacity:0.5;fill:url(#SVGID_39_);}\n\t.st41{fill:url(#SVGID_40_);}\n\t.st42{fill:url(#SVGID_41_);}\n\t.st43{opacity:0.5;fill:url(#SVGID_42_);}\n\t.st44{opacity:0.5;fill:url(#SVGID_43_);}\n\t.st45{fill:url(#SVGID_44_);}\n\t.st46{opacity:0.5;fill:url(#SVGID_45_);}\n\t.st47{opacity:0.5;fill:url(#SVGID_46_);}\n\t.st48{opacity:0.5;fill:url(#SVGID_47_);}\n\t.st49{fill:url(#SVGID_48_);}\n\t.st50{fill:url(#SVGID_49_);}\n\t.st51{opacity:0.5;fill:url(#SVGID_50_);}\n\t.st52{opacity:0.5;fill:url(#SVGID_51_);}\n\t.st53{fill:url(#SVGID_52_);}\n\t.st54{opacity:0.5;fill:url(#SVGID_53_);}\n\t.st55{opacity:0.5;fill:url(#SVGID_54_);}\n\t.st56{opacity:0.5;fill:url(#SVGID_55_);}\n\t.st57{fill:url(#SVGID_56_);}\n\t.st58{fill:url(#SVGID_57_);}\n\t.st59{opacity:0.5;fill:url(#SVGID_58_);}\n\t.st60{opacity:0.5;fill:url(#SVGID_59_);}\n\t.st61{fill:url(#SVGID_60_);}\n\t.st62{opacity:0.5;fill:url(#SVGID_61_);}\n\t.st63{opacity:0.5;fill:url(#SVGID_62_);}\n\t.st64{opacity:0.5;fill:url(#SVGID_63_);}\n\t.st65{fill:url(#SVGID_64_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "pepperoni"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.4133,
    y1: 314.8563,
    x2: 141.2925,
    y2: 257.6203,
    gradientTransform: "matrix(0.404 0.9148 -0.9148 0.404 406.8747 -69.2154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.5,178.1c3.6-12-1.1-25.8-12.9-31.2c-5.3-2.5-10.6-3.1-16.1-1.2c-4.2,1.5-8.6,3.8-10.5,5.7 c-9.4,9.3-11.8,25.6-10.5,37.6c0.6,5.9,2.5,12.6,8.2,15.9c4.5,2.6,10.8,0.1,15.4-1.5C212.7,199.1,223.8,190.4,227.5,178.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.9788,
    y1: 272.9371,
    x2: 147.128,
    y2: 272.9371,
    gradientTransform: "matrix(0.404 0.9148 -0.9148 0.404 406.8747 -69.2154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.6,172c1.9-2.2,2.3-13.1-7.4-19.5c-6-4-13-3.2-18.9-0.2c-3.5,1.8-2.7,5-0.7,6c5.6,3,10.7,6.1,15.4,10.3 C214.7,171.1,220.3,176.1,223.6,172z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.8571,
    y1: 294.254,
    x2: 163.4104,
    y2: 294.254,
    gradientTransform: "matrix(0.404 0.9148 -0.9148 0.404 406.8747 -69.2154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.5,198.2c3.3-2,6.2-4.4,8.9-7c3.4-3.2,1.4-4.1-2-3.7c-1.3,0.1-6.2-0.7-7.5-0.8c-3.4-0.5-6.7-2-10.1-2.3 c-4.6-0.4-10.5,1.9-10.6,7.3c-0.2,6.3,5,9.5,10.2,9.5C197.6,201.2,202.7,199.9,205.5,198.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.1708,
    y1: 178.6944,
    x2: 222.8203,
    y2: 178.6944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222.8,187.6c-3.7,3.8-13,11.7-22,15c-5.8,2.1-13.2,2.5-16.1,0.1c-2.9-2.4-9.4-7.2-5.9-30.6 c1.2-7.7,5.7-17.2,10.3-21.7c-6.9,4.6-10.5,13.1-12.5,21.9c-1.9,8.6-2.3,16.6,0.8,25.4c1.8,5.3,8.3,12.3,21.3,8 C214.1,200.6,220.7,191.1,222.8,187.6z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.4,194.4c-1.2,0.4-2.4,0.9-3.5,1.5c-0.6,0.3-1.5,0.7-1.1,1.5c0.4,0.8,3.4,1.6,5.4-1.7 C206.8,194.7,206.4,194.1,205.4,194.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M205.6,147.1c-0.6-0.5-3.3,0-5.2,0.8c-0.4,0.2-0.3,0.8,0.1,1c0.3,0.1,0.7,0.1,0.9,0.1c0.6,0,1.3-0.1,1.9-0.2 c0.7-0.1,1.8,0,2.3-0.6C206.1,147.9,206,147.4,205.6,147.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.2,149.9c-0.7-0.1-4,1.7-4.1,2.7c-0.1,1.8,2.9,0.1,3.5-0.2c0.6-0.3,1.4-0.7,1.4-1.5 C196.1,150.4,195.7,150,195.2,149.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M208,152.9c-0.1,0.8,0.9,1.2,1.5,1.5c0.6,0.3,1.6,0.8,2.3,0.6c0.7-0.2,0.8-1,0.6-1.6 C211.9,152.1,208.3,151,208,152.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.1,151.3c-2.1-0.1-0.1,3.4,0.8,4.4c0.6,0.7,1.6,1,2.3,0.2C220.7,154.2,217.9,151.4,216.1,151.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M212.4,148.1c-0.6-0.2-2.5-0.9-2.5,0.1c0,1.1,2.3,1.5,2.9,1.5c0.4,0,0.7-0.3,0.6-0.8 C213.2,148.5,212.8,148.3,212.4,148.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M205.5,151.7c-0.9-0.6-2.6-0.5-4,1.4c-0.6,0.9-0.6,2.1,0,3c0.5,0.9,1.7,1.7,2.8,1.4c1.3-0.5,1.1-2.1,1.7-3.1 C206.6,153.4,206.5,152.3,205.5,151.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.2,154.5c-1.1-0.1-3.7,1-3.8,2.2c-0.1,1.9,2.6,1.2,3.6,0.7c0.6-0.3,1.3-0.9,1.3-1.7 C198.4,155,197.9,154.6,197.2,154.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M188.8,158.8c-2.1,1.2-2.3,3.1-1.8,4c0.1,0.2,0.4,0.2,0.5,0.1c1.2-1,2.4-2.2,1.9-3.9 C189.3,158.7,189,158.6,188.8,158.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M208.7,167.7c-0.7-0.8-1.9-1-2.4,0.1c-0.3,0.7-0.3,1.5-0.2,2.2c0,0.9,0.1,1.8,1,2.3c1.1,0.5,2-0.4,2.3-1.4 C209.7,169.8,209.5,168.5,208.7,167.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.8,164.9c-1.1-0.8-2.9-0.1-3.5,1.8c-0.1,0.4-0.1,0.9,0.4,1c0.6,0.2,1.4-0.3,1.9-0.5 c0.5-0.2,1.2-0.4,1.5-0.9C204.3,165.8,204.2,165.2,203.8,164.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202.7,168.9c-1.6,0.9-1.4,3.4-0.5,4.1c0.6,0.5,1.7,0.6,2.1-0.2c0.5-0.8,0.5-2,0.2-2.9 C204.2,169.2,203.5,168.4,202.7,168.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.2,162.1c-0.9,0.2-3.7,2.6-2.2,3.8c0.7,0.5,1.8-0.2,2.3-0.6c0.6-0.4,1.7-1.2,1.7-2.1 C197,162.3,196,161.9,195.2,162.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.7,159c-0.3,0.7,0.5,1.9,0.8,2.6c0.3,0.6,0.7,1.4,1.4,1.6c0.8,0.3,1.3-0.6,1.5-1.3 C219.9,160.4,216.8,156.9,215.7,159z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210.2,160.1c-0.9,0.1-1.3,1-1.1,1.9c0.2,0.8,0.7,1.3,1.4,1.7c1,1,2.1,1.7,2.6,0.2 C213.6,162.3,211.9,159.8,210.2,160.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M225.4,165.3c-0.2-0.2-0.4-0.2-0.6-0.1c-0.5,0.2-0.8,0.5-1,1c-0.1,0.2-0.2,0.3-0.2,0.5 c-0.4,1-0.4,2.7,0.3,3.5c1,1.1,2.1-0.1,2.4-1.1C226.7,167.7,226.4,166.3,225.4,165.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.2,175.9c-0.4-0.8-1.3-0.7-1.9-0.2c-0.7,0.6-1.3,1.6-1.6,2.5c-0.2,0.4-0.4,0.9-0.4,1.4 c-0.1,0.3,0,0.6,0.1,0.9c1.1,1.9,3.1-1.1,3.5-2C223.2,177.8,223.6,176.7,223.2,175.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.7,198.8c-0.7-1-2.8-2.3-4-1.4c-0.6,0.4-0.4,2.1,1.8,3.1c0.6,0.3,1.7,0.5,2.3,0 C191.3,200,191,199.3,190.7,198.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M194.3,195.9c-0.7-0.1-1.6-0.5-2.3-0.3c-0.6,0.2-0.8,0.8-0.4,1.3c0.2,0.3,3.2,1.9,4,1.3 c0.5-0.4,0.7-1.1,0.4-1.6C195.7,196,194.9,196,194.3,195.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.6,188.5c-0.8,0-1.5,0.6-2,1.2c-0.5,0.7-1.2,1.6-1.2,2.5c0,0.2,0.1,0.3,0.1,0.5c0.1,0.4,0.4,0.7,0.9,1 c1.6,0.8,3.3,0,3.9-1.7C192.8,190.6,192.5,188.4,190.6,188.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183.6,187.2c-1-0.5-1.9,0.3-2.2,1.2c-0.3,1-0.1,2.1,0.5,3c0,0.1,0.1,0.1,0.1,0.2c0.4,0.7,1.4,1.9,2.3,1.7 c1.1-0.2,1-1.9,0.9-2.7C185.2,189.5,184.8,187.8,183.6,187.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.9,189.2c-0.8,0.4-1.5,0.8-2.2,1.3c-0.4,0.2-0.8,0.3-1.2,0.5c-0.8,0.3-1.7,0.4-2.4,0.8 c-0.9,0.5-0.5,1.4,0.4,1.7c2.2,0.7,6.5-1.1,6.2-3.8C203.6,189.4,203.2,189.1,202.9,189.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.4,188.2c-0.4-0.2-1.1-0.3-1.4,0.2c-0.2,0.2-0.2,0.6-0.2,1c-0.1,0.3,0,0.8,0.1,1.1 c0.2,0.5,0.6,0.9,1.1,1c1.2,0.2,1.8-0.9,1.4-2C196.2,188.9,195.8,188.4,195.4,188.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M186.5,165.5c-0.5,0.1-0.9,0.7-1.2,1.2c-0.8,0.7-1.3,2-1.1,3c0.1,0.6,0.4,1.3,1.1,1.2 c0.4-0.1,0.6-0.5,0.9-0.8c0.3-0.4,0.7-0.9,1-1.3c0.4-0.6,0.8-1.4,0.7-2.1C187.7,166,187.2,165.3,186.5,165.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.5,177.6c-0.6,0.4-0.8,1-0.8,1.7c-0.3,1.1-0.1,2.4,0.7,3.2c1.3,1.4,2.2-0.5,2.2-1.8 C188.7,179.9,188,176.6,186.5,177.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M212.2,180.8c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.5,0.3-1.1,0.6-1.5,1.1 c-0.6,0.7-0.5,1.8,0.5,2.1c1,0.3,2.3-0.5,3-1.2c0.6-0.6,1.6-1.8,1.1-2.7C213.9,179.5,212.8,180.2,212.2,180.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.5,168c-0.3,0.3,0.1,3.1,0.8,3.2c1.1,0.2,1.3-1.4,1.2-2.1C218.3,168.3,217.4,167.2,216.5,168z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217.5,173.5c-0.6,0.1-2.5,1.2-1.4,3c0.6,0.9,2-0.3,2.3-0.9C218.7,174.8,218.7,173.3,217.5,173.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M209.9,189.4c-1.2-0.5-2.3,0.7-2.8,1.7c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,1,2,0.7,2.6,0.3c0.5-0.3,0.9-0.7,1-1.3 C210.7,190.1,210.3,189.6,209.9,189.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183.3,180.4c-0.6-0.6-1.4-0.2-1.7,0.5c-0.3,0.6-0.3,1.4,0.1,2.1c0.1,0.2,0.2,0.3,0.4,0.4 c0.3,0.3,0.6,0.5,1.1,0.5c0.7-0.1,0.9-0.7,0.9-1.3c0-0.4-0.2-0.9-0.3-1.3C183.6,180.9,183.5,180.6,183.3,180.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.6,182c-0.3-0.5-0.9-1.1-1.5-0.7c-0.4,0.3-0.9,2.2,0.6,4.2c0.4,0.5,1,0.9,1.6,0.7 c0.6-0.2,0.6-0.9,0.4-1.4C193.3,183.9,193.1,182.9,192.6,182z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.5,169.1c-0.5-0.1-1.2,0.2-1.7,0.7c-0.6,0.4-1,1.1-1,1.6c-0.1,1.8,2.2,1,3,0.4c0.5-0.3,1-0.8,1-1.5 C196.7,169.7,196.1,169.2,195.5,169.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.8,179.3c-0.4-0.4-0.8-0.8-1.2-1.1c-0.6-0.4-1.5-0.5-2,0.3c-0.4,0.7,1.1,3.4,3.1,3.5 c0.8,0,1.1-1,0.9-1.7C200.5,179.9,200.1,179.6,199.8,179.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M208,176.2c-0.3,0.3-1.6,1.4-1.8,1.8c-0.4,0.5-0.3,1.3,0.4,1.6c1.3,0.6,2.9-1,3.1-2.2 C209.7,176.8,209.8,174.6,208,176.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.8211,
    y1: 155.8816,
    x2: 199.2752,
    y2: 155.8816,
    gradientTransform: "matrix(0.94 -0.3412 0.3412 0.94 -50.7197 79.5631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.3,155.3c-2.6,2.5-4.2,7.1-4.3,8.5c-0.2,2.2,2.2-2.1,2.7-3.1c1-1.7,1.9-3.5,2.9-5.2 C188.8,155.2,188.7,154,187.3,155.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.6185,
    y1: 166.9935,
    x2: 189.9789,
    y2: 166.9935,
    gradientTransform: "matrix(0.94 -0.3412 0.3412 0.94 -50.7197 79.5631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M182.2,166.3c-1.2,3-2.2,6.3-2.5,9.5c-0.1,0.8-0.2,1.6-0.1,2.4c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0.1,0.2 c0.1,0.3,0.1,0.6,0.3,0.8c0.1,0.2,0.3,0.2,0.4,0c0.5-2.4,0.9-4.8,1.4-7.2c0.5-2,1.3-4,1.2-6.1C182.9,166.1,182.3,166,182.2,166.3 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.9736,
    y1: 191.3041,
    x2: 222.2566,
    y2: 191.3041,
    gradientTransform: "matrix(0.94 -0.3412 0.3412 0.94 -50.7197 79.5631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M222.2,181.5c-0.9,0.6-1.4,1.5-2,2.4c-0.9,0.9-1.9,1.7-2.7,2.6c-0.5,0.6-0.4,1.4,0.5,1.4 c1.2,0.1,2.5-1.6,3.3-2.4c1-1,1.8-2.3,1.6-3.7C222.8,181.5,222.4,181.3,222.2,181.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.7593,
    y1: 165.8872,
    x2: 186.9515,
    y2: 201.9274,
    gradientTransform: "matrix(0.94 -0.3412 0.3412 0.94 -50.7197 79.5631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M195.9,203.3c-3.4,0.6-7.1,0.6-10.3-0.8c-2.8-1.2-4.7-3.9-6.1-6.7c-1.4-3.6-1.7-7.7-1.7-10.9 c0-8,1.9-16.5,4.4-23.7c-3.3,4.9-5.8,19.3-4.9,28.1c0.1,1.3,0.6,5.9,2.3,8.7c2.2,3.8,6.1,6.3,8.5,6.5c1.8,0.4,3.6,0.5,5.4,0.3 c8.5-0.7,18.2-6.7,24.1-12.5C215.1,193.9,203.8,202,195.9,203.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.5187,
    y1: 383.8107,
    x2: 238.3979,
    y2: 326.5738,
    gradientTransform: "matrix(-5.160000e-02 0.9987 -0.9987 -5.160000e-02 546.2155 72.5286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M200.8,305.9c8.6-9.1,10.6-23.6,2.6-33.7c-3.6-4.6-8.1-7.6-13.9-8.3c-4.4-0.6-9.4-0.5-12,0.3 c-12.6,4.1-22,17.5-26.3,28.8c-2.1,5.5-3.5,12.4,0.1,17.8c2.9,4.3,9.6,5,14.5,5.6C178.1,318,191.9,315.2,200.8,305.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.0844,
    y1: 341.8904,
    x2: 244.2341,
    y2: 341.8904,
    gradientTransform: "matrix(-5.160000e-02 0.9987 -0.9987 -5.160000e-02 546.2155 72.5286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M200,298.7c2.7-1.2,7.9-10.7,2.2-20.8c-3.5-6.2-10.1-8.7-16.8-8.7c-4,0-4.6,3.3-3.3,5.1 c3.7,5.2,6.8,10.3,9.1,16.2C192.5,293.9,195.2,300.8,200,298.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9621,
    y1: 363.2083,
    x2: 260.5157,
    y2: 363.2083,
    gradientTransform: "matrix(-5.160000e-02 0.9987 -0.9987 -5.160000e-02 546.2155 72.5286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172.1,314c3.8-0.3,7.5-1.1,11.1-2.2c4.5-1.3,3.1-3-0.1-4.2c-1.2-0.4-5.2-3.4-6.3-4.1 c-2.9-2-5.1-4.8-8-6.6c-3.9-2.4-10.2-3-12.8,1.7c-3,5.5,0.2,10.8,4.8,13.1C163.7,313.1,168.8,314.2,172.1,314z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.6553,
    y1: 295.1699,
    x2: 199.3039,
    y2: 295.1699,
    gradientTransform: "matrix(0.8927 0.4507 -0.4507 0.8927 151.4307 -49.0082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M192.3,312.3c-5,1.7-16.9,4.6-26.4,3.5c-6.1-0.7-12.9-3.8-14.4-7.2c-1.5-3.4-5.1-10.7,8.6-30 c4.5-6.3,12.8-12.7,19-14.7c-8.2,1-15.3,6.9-21,13.9c-5.5,6.8-9.5,13.8-10.7,23c-0.8,5.6,1.9,14.7,15.5,16.8 C178.7,319.9,188.8,314.5,192.3,312.3z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.7,310.5c-1.3-0.2-2.5-0.3-3.8-0.2c-0.6,0-1.6,0-1.6,0.8c0,0.9,2.3,3,5.6,0.9 C174.8,311.4,174.7,310.6,173.7,310.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.2,268.4c-0.3-0.7-2.9-1.5-5-1.7c-0.4,0-0.6,0.6-0.3,1c0.2,0.2,0.6,0.4,0.8,0.5c0.6,0.3,1.2,0.5,1.8,0.7 c0.6,0.2,1.7,0.8,2.4,0.6C195.3,269.3,195.4,268.8,195.2,268.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M184.7,266.2c-0.6-0.4-4.4-0.3-4.8,0.6c-0.9,1.6,2.5,1.4,3.3,1.4c0.7,0,1.5,0,1.9-0.7 C185.2,267,185.1,266.5,184.7,266.2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.7,274.6c-0.5,0.7,0.2,1.5,0.6,2c0.4,0.6,1.1,1.4,1.8,1.6c0.7,0.1,1.2-0.5,1.3-1.2 C198.6,275.6,195.8,273,194.7,274.6z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202.7,276.9c-1.8-1.1-1.6,3-1.3,4.3c0.2,0.9,1,1.6,1.9,1.2C205.5,281.5,204.2,277.8,202.7,276.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.8,272.3c-0.4-0.5-1.8-2-2.3-1c-0.5,1,1.4,2.4,1.9,2.6c0.4,0.2,0.8,0,0.9-0.4 C201.4,273.1,201,272.7,200.8,272.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M193,272.4c-0.6-0.9-2.1-1.6-4.2-0.6c-1,0.5-1.5,1.6-1.4,2.7c0.1,1,0.7,2.3,1.9,2.5c1.4,0.2,2-1.4,2.9-2 C193.2,274.4,193.7,273.4,193,272.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M184.4,271.2c-0.9-0.6-3.8-0.7-4.3,0.2c-1,1.7,1.8,2.3,2.9,2.3c0.7,0,1.5-0.2,1.9-0.9 C185.2,272.2,184.9,271.5,184.4,271.2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.9,271.2c-2.5,0.2-3.4,1.7-3.4,2.8c0,0.2,0.2,0.4,0.4,0.3c1.5-0.3,3.1-0.9,3.4-2.6 C175.5,271.3,175.2,271.1,174.9,271.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.7,288.1c-0.3-1-1.2-1.7-2.2-1c-0.6,0.4-1,1.2-1.1,1.9c-0.4,0.8-0.7,1.7-0.1,2.5c0.7,1,2,0.5,2.6-0.2 C188.7,290.5,189,289.2,188.7,288.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.5,283.5c-0.6-1.2-2.6-1.4-3.9,0c-0.3,0.3-0.4,0.7-0.1,1.1c0.4,0.4,1.4,0.4,1.9,0.5 c0.6,0.1,1.2,0.2,1.7-0.2C185.6,284.5,185.8,283.9,185.5,283.5z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.8,286.5c-1.8,0.1-2.8,2.4-2.3,3.5c0.3,0.7,1.2,1.3,2,0.8c0.8-0.5,1.4-1.6,1.5-2.5 C184,287.4,183.7,286.4,182.8,286.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.2,277c-0.9-0.2-4.5,0.7-3.7,2.4c0.4,0.8,1.7,0.6,2.3,0.5c0.8-0.1,2.1-0.3,2.4-1.1 C180.6,278,180,277.2,179.2,277z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.9,283.5c-0.6,0.4-0.4,2-0.4,2.6c0,0.7,0,1.5,0.6,2.1c0.6,0.6,1.5,0.1,1.9-0.5 C202,286.6,200.7,282.1,198.9,283.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193.4,282c-0.9-0.3-1.6,0.3-1.8,1.2c-0.2,0.8,0.1,1.5,0.4,2.2c0.4,1.3,1.1,2.5,2.3,1.4 C195.5,285.6,195.1,282.6,193.4,282z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.7,293.5c-0.1-0.2-0.3-0.3-0.5-0.4c-0.6-0.1-1,0.1-1.4,0.5c-0.2,0.1-0.3,0.2-0.4,0.3 c-0.8,0.7-1.6,2.2-1.3,3.3c0.4,1.4,1.9,0.9,2.6,0.1C204.7,296.2,205.1,294.9,204.7,293.5z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.9,302c0-0.9-0.9-1.2-1.6-1.1c-0.9,0.2-1.9,0.9-2.6,1.5c-0.3,0.3-0.7,0.6-1,1.1 c-0.2,0.2-0.3,0.5-0.3,0.9c0.1,2.2,3.2,0.4,4-0.2C197,303.7,197.9,302.9,197.9,302z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M158.5,307.8c-0.2-1.2-1.4-3.3-2.9-3c-0.7,0.1-1.3,1.7,0.2,3.5c0.4,0.5,1.3,1.2,2,1 C158.5,309.1,158.6,308.4,158.5,307.8z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.1,306.8c-0.5-0.4-1.2-1.2-1.9-1.3c-0.6-0.1-1.1,0.4-1,1c0.1,0.4,2,3.2,3,3c0.6-0.1,1.1-0.6,1.1-1.2 C164.3,307.6,163.6,307.2,163.1,306.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.1,298.6c-0.8-0.3-1.6-0.1-2.3,0.2c-0.8,0.4-1.8,0.8-2.2,1.7c-0.1,0.2-0.1,0.3-0.1,0.5 c-0.1,0.4,0,0.8,0.4,1.3c1.1,1.4,3,1.5,4.2,0.3C164.1,301.4,164.9,299.3,163.1,298.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.5,294.3c-0.7-0.9-1.8-0.6-2.5,0.1c-0.7,0.8-1,1.9-0.9,2.9c0,0.1,0,0.1,0,0.2c0.1,0.8,0.4,2.3,1.3,2.6 c1,0.3,1.8-1.2,2-2C157.8,297,158.2,295.3,157.5,294.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173.7,304.7c-0.8,0-1.7,0.1-2.6,0.2c-0.4,0-0.9-0.1-1.3-0.1c-0.8-0.1-1.7-0.4-2.5-0.3c-1,0.1-1.1,1-0.4,1.7 c1.6,1.7,6.3,2,7.3-0.5C174.4,305.2,174.2,304.8,173.7,304.7z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.5,300.4c-0.3-0.4-0.8-0.7-1.3-0.5c-0.3,0.1-0.5,0.4-0.6,0.8c-0.3,0.2-0.4,0.7-0.4,1 c0,0.5,0.2,1.1,0.6,1.4c1,0.8,2.1,0,2.1-1.1C167.9,301.4,167.9,300.8,167.5,300.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M169.9,276.2c-0.5-0.1-1.1,0.2-1.6,0.5c-1.1,0.2-2,1.2-2.4,2.2c-0.2,0.5-0.2,1.3,0.5,1.5 c0.4,0.1,0.8-0.1,1.1-0.3c0.5-0.2,1-0.5,1.4-0.8c0.7-0.4,1.3-0.9,1.6-1.6C170.7,277.1,170.6,276.3,169.9,276.2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.4,286.9c-0.7,0.1-1.2,0.6-1.5,1.2c-0.8,0.8-1.2,2.1-0.8,3.2c0.6,1.8,2.2,0.5,2.8-0.6 C165.3,290,166.2,286.7,164.4,286.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.9,301.4c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4,0c-0.6,0.1-1.3,0.1-1.8,0.3c-0.8,0.3-1.3,1.4-0.5,2.1 c0.8,0.7,2.3,0.6,3.2,0.3c0.8-0.2,2.2-0.9,2.2-1.9C188,301,186.7,301.2,185.9,301.4z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.5,291.9c-0.4,0.1-1.3,2.8-0.7,3.2c0.9,0.7,1.8-0.6,2-1.4C197,293,196.6,291.6,195.5,291.9z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193.9,297.3c-0.6-0.2-2.8-0.1-2.6,2c0.1,1.1,1.9,0.7,2.5,0.2C194.4,299,195.1,297.6,193.9,297.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179.9,308.1c-0.8-0.9-2.4-0.4-3.3,0.2c-0.2,0.1-0.2,0.3-0.2,0.5c-0.3,0.9,1.5,1.5,2.2,1.5 c0.5,0,1.2-0.2,1.4-0.7C180.4,309,180.3,308.5,179.9,308.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M160.3,288c-0.3-0.8-1.2-0.8-1.7-0.3c-0.6,0.4-0.9,1.2-0.9,1.9c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.4,0.3,0.7,0.7,0.9c0.6,0.2,1.1-0.2,1.4-0.8c0.2-0.4,0.2-0.9,0.3-1.3C160.3,288.6,160.4,288.3,160.3,288z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.8,293.7c0-0.6-0.3-1.4-1-1.3c-0.5,0.1-1.8,1.6-1.4,4c0.1,0.6,0.5,1.2,1.2,1.3c0.7,0.1,1-0.5,1-1.1 C167.6,295.6,167.9,294.6,167.8,293.7z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M176.2,283.4c-0.4-0.3-1.2-0.4-1.8-0.2c-0.7,0.1-1.4,0.5-1.7,1c-0.9,1.6,1.5,1.9,2.5,1.7 c0.6-0.1,1.3-0.3,1.5-0.9C177,284.5,176.7,283.8,176.2,283.4z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.5,294.5c-0.2-0.5-0.4-1-0.6-1.5c-0.4-0.7-1.2-1.1-1.9-0.7c-0.7,0.5-0.6,3.5,1.2,4.5 c0.7,0.4,1.5-0.4,1.5-1.1C175.8,295.3,175.7,294.9,175.5,294.5z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.3,295.4c-0.4,0.1-2.1,0.6-2.5,0.8c-0.6,0.3-0.8,1.1-0.4,1.6c0.9,1.1,3.1,0.4,3.7-0.6 C185.4,296.7,186.6,294.8,184.3,295.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.5252,
    y1: 258.0909,
    x2: 136.9796,
    y2: 258.0909,
    gradientTransform: "matrix(0.9929 0.119 -0.119 0.9929 70.8144 -1.5166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M175.1,267.5c-3.5,1.1-6.9,4.4-7.7,5.6c-1.1,1.9,2.9-0.9,3.8-1.5c1.6-1.1,3.3-2.2,4.9-3.4 C176.5,268,177,266.9,175.1,267.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.322,
    y1: 269.2023,
    x2: 127.683,
    y2: 269.2023,
    gradientTransform: "matrix(0.9929 0.119 -0.119 0.9929 70.8144 -1.5166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M165.6,275c-2.4,2.1-4.8,4.6-6.6,7.3c-0.5,0.7-0.9,1.4-1.2,2.1c-0.1,0.1-0.1,0.3-0.2,0.4c0,0.1,0,0.2,0,0.2 c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.2,0.2,0.3,0.3,0.1c1.5-1.9,2.9-3.9,4.5-5.8c1.3-1.6,2.9-3,3.8-4.9 C166.4,275.1,165.9,274.7,165.6,275z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.6761,
    y1: 293.5147,
    x2: 159.9593,
    y2: 293.5147,
    gradientTransform: "matrix(0.9929 0.119 -0.119 0.9929 70.8144 -1.5166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M194.5,306.6c-1.1,0.1-1.9,0.8-2.9,1.2c-1.2,0.4-2.4,0.6-3.6,1.1c-0.7,0.3-1,1-0.2,1.5c1,0.6,3-0.3,4-0.6 c1.3-0.5,2.6-1.2,3.2-2.6C195,306.8,194.8,306.5,194.5,306.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.4628,
    y1: 268.0958,
    x2: 124.6546,
    y2: 304.1368,
    gradientTransform: "matrix(0.9929 0.119 -0.119 0.9929 70.8144 -1.5166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M161.2,314.2c-3.3-1-6.6-2.7-8.9-5.3c-2-2.3-2.4-5.6-2.4-8.7c0.4-3.8,2-7.7,3.4-10.5 c3.6-7.1,9.2-13.9,14.6-19.2c-5.1,2.9-13.9,14.7-17,22.9c-0.5,1.2-2.1,5.5-1.9,8.8c0.3,4.4,2.6,8.4,4.7,9.7 c1.4,1.2,3,2.1,4.7,2.7c7.9,3.2,19.2,2.2,27.2-0.3C182.6,314.5,168.8,316.5,161.2,314.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.824,
    y1: 322.139,
    x2: 224.7035,
    y2: 264.8985,
    gradientTransform: "matrix(0.8417 -0.5399 0.5399 0.8417 -78.4441 109.5204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M267.6,209.8c-12.4-1.7-25.3,5.1-28.9,17.6c-1.6,5.6-1.4,11,1.3,16.1c2.1,3.9,5.1,7.9,7.2,9.5 c10.7,7.9,27.1,7.7,38.8,4.6c5.7-1.5,12.1-4.4,14.4-10.5c1.8-4.8-1.6-10.7-3.9-15C290.7,221.2,280.4,211.5,267.6,209.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.3889,
    y1: 280.2159,
    x2: 230.5405,
    y2: 280.2159,
    gradientTransform: "matrix(0.8417 -0.5399 0.5399 0.8417 -78.4441 109.5204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M262.3,214.6c-2.5-1.5-13.3-0.2-18.1,10.3c-3,6.5-1.2,13.3,2.7,18.7c2.3,3.2,5.4,1.9,6.1-0.2 c2.1-6,4.4-11.5,7.8-16.8C262.6,223.5,266.8,217.2,262.3,214.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.2676,
    y1: 301.5356,
    x2: 246.8225,
    y2: 301.5356,
    gradientTransform: "matrix(0.8417 -0.5399 0.5399 0.8417 -78.4441 109.5204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M290.9,228.4c-2.4-2.9-5.3-5.4-8.3-7.8c-3.7-2.9-4.3-0.8-3.3,2.5c0.3,1.2,0.3,6.2,0.3,7.5 c0.1,3.5-0.9,6.9-0.7,10.4c0.3,4.6,3.5,10.1,8.8,9.4c6.2-0.8,8.6-6.4,7.8-11.5C295.1,235.8,293,230.9,290.9,228.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.058,
    y1: 257.5148,
    x2: 250.7077,
    y2: 257.5148,
    gradientTransform: "matrix(-0.1538 -0.9881 0.9881 -0.1538 53.0614 501.6561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M277.8,213c4.4,3.1,13.6,11.1,18.2,19.5c3,5.4,4.5,12.7,2.6,15.9c-1.9,3.2-5.7,10.4-29.3,10.5 c-7.8,0-17.8-3-23-6.8c5.6,6.1,14.5,8.4,23.5,9c8.7,0.6,16.7-0.3,24.9-4.7c5-2.6,10.8-10.1,4.6-22.3 C291.9,219.6,281.6,214.5,277.8,213z"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.2,229.1c0.6,1.1,1.3,2.2,2,3.2c0.4,0.5,0.9,1.3,1.6,0.8c0.7-0.5,1.1-3.6-2.5-5.1 C287.2,227.7,286.7,228.2,287.2,229.1z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.4,236.1c-0.4,0.7,0.5,3.2,1.6,5c0.2,0.4,0.9,0.2,1-0.3c0.1-0.3,0-0.7-0.1-0.9c-0.1-0.6-0.3-1.3-0.5-1.9 c-0.2-0.6-0.3-1.8-0.9-2.2C241.1,235.6,240.6,235.7,240.4,236.1z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.8,246c0,0.8,2.3,3.7,3.3,3.6c1.8-0.2-0.3-2.8-0.8-3.5c-0.4-0.5-0.9-1.3-1.7-1.2 C245.1,245.1,244.8,245.5,244.8,246z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M245.8,232.9c0.8,0,1.1-1.1,1.3-1.7c0.2-0.7,0.6-1.7,0.2-2.4c-0.3-0.7-1.1-0.7-1.7-0.4 C244.3,229.2,243.8,233,245.8,232.9z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M242.9,225.1c0.2,2.1,3.4-0.4,4.3-1.5c0.6-0.7,0.8-1.7-0.1-2.3C245.1,220.2,242.8,223.4,242.9,225.1z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M240.4,229.3c-0.2,0.6-0.5,2.6,0.5,2.5c1.1-0.1,1.1-2.5,1-3.1c-0.1-0.4-0.4-0.7-0.8-0.5 C240.6,228.4,240.5,228.9,240.4,229.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.9,235.6c-0.4,1,0,2.7,2,3.7c1,0.5,2.2,0.2,3-0.4c0.8-0.7,1.4-2,0.9-3c-0.7-1.2-2.2-0.8-3.3-1.2 C246.5,234.3,245.4,234.5,244.9,235.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M249,243.4c0,1.1,1.6,3.5,2.7,3.4c1.9-0.2,0.8-2.8,0.2-3.7c-0.4-0.6-1.1-1.1-1.8-1.1 C249.3,242.1,249,242.7,249,243.4z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.5,251c1.6,1.9,3.4,1.8,4.2,1.1c0.1-0.1,0.1-0.4,0-0.5c-1.1-1-2.6-2-4.1-1.3 C254.3,250.5,254.3,250.8,254.5,251z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M260.2,229.9c-0.6,0.8-0.7,2,0.4,2.4c0.7,0.2,1.5,0.1,2.2-0.2c0.9-0.1,1.8-0.4,2.1-1.3 c0.4-1.1-0.7-1.9-1.7-2C262.2,228.6,260.9,229,260.2,229.9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.3,235.3c-0.6,1.2,0.4,2.9,2.3,3.2c0.4,0.1,0.9-0.1,0.9-0.6c0.1-0.6-0.5-1.3-0.8-1.9 c-0.3-0.5-0.5-1.1-1.1-1.3C259.1,234.6,258.5,234.8,258.3,235.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M262.3,235.7c1.1,1.4,3.6,0.9,4.2-0.2c0.4-0.7,0.3-1.7-0.5-2.1c-0.9-0.4-2.1-0.2-2.9,0.3 C262.4,234.1,261.8,235,262.3,235.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256.7,244.1c0.3,0.9,3.2,3.3,4.1,1.6c0.4-0.7-0.5-1.7-0.9-2.2c-0.5-0.6-1.4-1.5-2.3-1.3 C256.7,242.4,256.4,243.4,256.7,244.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.6,224.4c0.7,0.2,1.8-0.8,2.4-1.2c0.6-0.4,1.2-0.9,1.4-1.7c0.1-0.9-0.8-1.2-1.5-1.3 C251.3,220,248.3,223.7,250.6,224.4z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M252.5,229.7c0.3,0.9,1.2,1.1,2,0.8c0.7-0.3,1.2-0.9,1.5-1.6c0.8-1.1,1.4-2.4-0.2-2.6 C254.2,226,252,228,252.5,229.7z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M255.3,213.8c-0.1,0.2-0.1,0.5,0,0.6c0.3,0.5,0.7,0.7,1.2,0.8c0.2,0.1,0.3,0.1,0.5,0.1c1,0.2,2.7,0,3.4-0.9 c0.9-1.1-0.4-2.1-1.5-2.2C257.5,212.2,256.1,212.7,255.3,213.8z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266.2,214.4c-0.7,0.5-0.5,1.4,0.1,1.9c0.7,0.6,1.8,1,2.7,1.2c0.4,0.1,0.9,0.2,1.5,0.2 c0.3,0,0.6-0.1,0.9-0.3c1.7-1.3-1.5-2.9-2.5-3.1C268,214.1,266.9,213.9,266.2,214.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293.8,243c-0.9,0.9-1.9,3.1-0.7,4.1c0.5,0.5,2.1,0.1,2.8-2.2c0.2-0.6,0.2-1.8-0.3-2.3 C294.9,242.2,294.2,242.6,293.8,243z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M290.3,239.9c0,0.7-0.3,1.6,0.1,2.3c0.3,0.5,1,0.6,1.4,0.2c0.3-0.3,1.4-3.5,0.7-4.2 c-0.4-0.4-1.1-0.5-1.6-0.2C290.2,238.4,290.3,239.3,290.3,239.9z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.6,244.6c0.2,0.8,0.8,1.4,1.5,1.8c0.7,0.4,1.7,1,2.6,0.8c0.2,0,0.3-0.1,0.4-0.2c0.4-0.2,0.7-0.5,0.8-1 c0.5-1.7-0.5-3.3-2.2-3.6C285.4,242.2,283.2,242.8,283.6,244.6z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.4,251.7c-0.4,1.1,0.6,1.8,1.6,1.9c1,0.1,2.1-0.2,2.9-1c0.1,0,0.1-0.1,0.2-0.1c0.6-0.5,1.6-1.7,1.4-2.6 c-0.3-1-2-0.7-2.8-0.5C285.4,249.9,283.8,250.5,283.4,251.7z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.4,232.4c0.5,0.7,1,1.4,1.6,2c0.2,0.4,0.4,0.7,0.6,1.1c0.4,0.7,0.7,1.6,1.2,2.2c0.7,0.8,1.5,0.3,1.6-0.6 c0.4-2.3-2-6.3-4.7-5.6C282.5,231.6,282.2,232.1,282.4,232.4z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.5,240c-0.2,0.5-0.1,1.1,0.4,1.3c0.3,0.1,0.6,0.1,1,0.1c0.3,0.1,0.8-0.1,1-0.3c0.5-0.3,0.8-0.7,0.8-1.3 c0-1.3-1.2-1.7-2.2-1C283.1,239.1,282.7,239.5,282.5,240z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M261.5,252.2c0.2,0.5,0.8,0.8,1.3,1c0.8,0.7,2.2,1,3.1,0.7c0.6-0.2,1.2-0.6,1-1.3c-0.1-0.4-0.5-0.6-0.9-0.8 c-0.5-0.3-1-0.5-1.5-0.7c-0.7-0.3-1.5-0.6-2.2-0.3C261.8,251,261.2,251.6,261.5,252.2z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M273.4,250.4c0.5,0.5,1.1,0.6,1.8,0.5c1.1,0.2,2.4-0.3,3.1-1.2c1.1-1.5-0.9-2.1-2.1-1.9 C275.4,247.9,272.2,249.1,273.4,250.4z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.6,224.6c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.4,0.8,1,1.3,1.3c0.8,0.5,1.9,0.2,2-0.8 c0.1-1-0.9-2.2-1.6-2.8c-0.7-0.5-2-1.3-2.8-0.7C271.1,223,272,224,272.6,224.6z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M259.3,222.2c0.3,0.3,3-0.6,3-1.3c0-1.1-1.6-1.1-2.3-0.8C259.3,220.4,258.4,221.5,259.3,222.2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M264.6,220.4c0.2,0.6,1.5,2.3,3.2,1c0.8-0.7-0.5-1.9-1.2-2.1C265.8,218.9,264.2,219.2,264.6,220.4z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M281.6,225.5c-0.3,1.2,1.1,2.2,2.1,2.5c0.2,0.1,0.4,0,0.5-0.1c0.9-0.3,0.3-2.1-0.1-2.7 c-0.3-0.4-0.9-0.8-1.4-0.8C282.1,224.5,281.7,225,281.6,225.5z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M276.7,253.1c-0.5,0.7,0,1.4,0.7,1.6c0.7,0.2,1.5,0.1,2-0.4c0.1-0.1,0.3-0.3,0.4-0.4 c0.3-0.3,0.4-0.7,0.3-1.1c-0.2-0.6-0.8-0.8-1.4-0.7c-0.4,0.1-0.9,0.3-1.3,0.5C277.1,252.7,276.9,252.9,276.7,253.1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M276.9,243.7c-0.5,0.4-0.9,1.1-0.4,1.6c0.3,0.4,2.3,0.6,4-1.2c0.4-0.4,0.7-1.1,0.4-1.7 c-0.3-0.6-1-0.5-1.4-0.2C278.6,242.7,277.7,243.1,276.9,243.7z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.7,242.8c0,0.6,0.4,1.2,0.9,1.6c0.5,0.5,1.2,0.9,1.8,0.8c1.8-0.2,0.6-2.3-0.1-3c-0.4-0.4-1-0.8-1.6-0.7 C264.1,241.6,263.7,242.2,263.7,242.8z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M273.1,236.9c-0.3,0.4-0.6,0.9-0.9,1.4c-0.3,0.7-0.2,1.6,0.6,1.9c0.8,0.3,3.2-1.6,3-3.6 c-0.1-0.8-1.1-1-1.8-0.6C273.6,236.2,273.4,236.6,273.1,236.9z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.7,229.3c0.3,0.3,1.7,1.4,2.1,1.5c0.6,0.3,1.4,0.1,1.6-0.6c0.4-1.4-1.4-2.7-2.7-2.7 C269.1,227.6,266.9,227.8,268.7,229.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.4012,
    y1: 239.8654,
    x2: 198.8557,
    y2: 239.8654,
    gradientTransform: "matrix(-0.4817 -0.8763 0.8763 -0.4817 139.2782 539.9355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M251.3,253c2.9,2.2,7.6,3.1,9,2.9c2.2-0.2-2.4-1.8-3.5-2.2c-1.9-0.7-3.7-1.4-5.6-2 C250.9,251.6,249.8,251.8,251.3,253z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.1982,
    y1: 250.9776,
    x2: 189.5589,
    y2: 250.9776,
    gradientTransform: "matrix(-0.4817 -0.8763 0.8763 -0.4817 139.2782 539.9355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M263,256.4c3.1,0.7,6.5,1.2,9.8,1.1c0.8,0,1.6-0.1,2.4-0.3c0.2,0,0.3,0,0.5-0.1c0.1,0,0.2-0.1,0.2-0.1 c0.3-0.1,0.5-0.2,0.8-0.4c0.2-0.1,0.1-0.3-0.1-0.4c-2.4-0.1-4.9-0.1-7.3-0.3c-2-0.2-4.2-0.6-6.2-0.2 C262.6,255.7,262.6,256.3,263,256.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.5544,
    y1: 275.2895,
    x2: 221.8378,
    y2: 275.2895,
    gradientTransform: "matrix(-0.4817 -0.8763 0.8763 -0.4817 139.2782 539.9355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M271.9,214.5c0.7,0.8,1.7,1.1,2.7,1.6c1,0.8,1.9,1.6,3,2.3c0.7,0.4,1.4,0.2,1.3-0.7c-0.1-1.2-2-2.3-2.8-2.9 c-1.2-0.8-2.5-1.4-4-1.1C271.7,213.9,271.6,214.3,271.9,214.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.34,
    y1: 249.8713,
    x2: 186.5313,
    y2: 285.9131,
    gradientTransform: "matrix(-0.4817 -0.8763 0.8763 -0.4817 139.2782 539.9355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M297.5,237.1c1.1,3.3,1.7,6.9,0.8,10.3c-0.7,3-3.2,5.2-5.7,7.1c-3.3,1.9-7.4,2.9-10.5,3.3 c-7.9,1.2-16.6,0.6-24.1-0.7c5.4,2.5,20,2.7,28.5,0.5c1.2-0.3,5.7-1.5,8.2-3.6c3.4-2.8,5.3-7,5.1-9.4c0.1-1.8-0.1-3.7-0.5-5.4 c-2-8.3-9.4-16.9-16.1-21.9C285.2,219.6,294.9,229.6,297.5,237.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.5895,
    y1: 364.2423,
    x2: 25.4688,
    y2: 307.004,
    gradientTransform: "matrix(0.1966 0.9805 -0.9805 0.1966 437.9355 -0.9061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M138.1,97.9c6.1-10.9,4.5-25.5-5.8-33.3c-4.7-3.5-9.7-5.3-15.5-4.6c-4.4,0.5-9.2,1.8-11.5,3.3 c-11.2,7-17,22.4-18.4,34.4c-0.7,5.9-0.3,12.9,4.5,17.3c3.8,3.5,10.5,2.4,15.4,1.8C119.1,115.2,131.9,109.1,138.1,97.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.1551,
    y1: 322.3207,
    x2: 31.3056,
    y2: 322.3207,
    gradientTransform: "matrix(0.1966 0.9805 -0.9805 0.1966 437.9355 -0.9061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M135.6,91.1c2.3-1.8,5.1-12.3-3-20.7c-5-5.1-12-6-18.4-4.2c-3.8,1-3.7,4.3-2,5.8 c4.8,4.1,9.1,8.3,12.8,13.4C127.2,88.3,131.5,94.4,135.6,91.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.0327,
    y1: 343.6396,
    x2: 47.5868,
    y2: 343.6396,
    gradientTransform: "matrix(0.1966 0.9805 -0.9805 0.1966 437.9355 -0.9061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M112.3,112.8c3.6-1.2,7-3,10.2-4.9c4-2.4,2.2-3.7-1.2-4c-1.3-0.1-5.9-2-7.1-2.4c-3.3-1.2-6.1-3.4-9.4-4.4 c-4.4-1.4-10.6-0.4-12,4.8c-1.6,6.1,2.8,10.4,7.9,11.5C104,114,109.2,113.8,112.3,112.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.032,
    y1: 93.021,
    x2: 131.6828,
    y2: 93.021,
    gradientTransform: "matrix(0.9763 0.2163 -0.2163 0.9763 24.9946 -21.8257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M131.5,106.2c-4.5,2.9-15.3,8.6-24.8,9.9c-6.1,0.8-13.4-0.4-15.7-3.4c-2.3-3-7.6-9.1,0.9-31.2 c2.8-7.3,9.3-15.5,14.7-19c-7.7,3-13.1,10.5-16.9,18.6c-3.7,7.9-5.8,15.7-4.7,24.9c0.6,5.6,5.5,13.8,19.1,12.4 C120.2,117,128.7,109.2,131.5,106.2z"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113,109.1c-1.3,0.2-2.5,0.4-3.8,0.7c-0.6,0.2-1.6,0.4-1.4,1.2c0.2,0.8,3,2.3,5.6-0.5 C114.4,109.6,114.1,108.9,113,109.1z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M123.5,62.9c-0.5-0.6-3.2-0.7-5.2-0.4c-0.4,0.1-0.5,0.7-0.1,1.1c0.2,0.2,0.6,0.2,0.9,0.3 c0.6,0.1,1.3,0.2,1.9,0.2c0.7,0.1,1.8,0.4,2.4,0C123.8,63.8,123.8,63.3,123.5,62.9z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.7,63.4c-0.7-0.3-4.3,0.8-4.6,1.7c-0.5,1.8,2.8,0.7,3.5,0.5c0.6-0.2,1.5-0.4,1.7-1.1 C113.5,64,113.2,63.6,112.7,63.4z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M124.5,69.1c-0.3,0.8,0.6,1.4,1.1,1.8c0.6,0.5,1.4,1.1,2.1,1.1c0.7-0.1,1-0.8,1-1.5 C128.5,69.1,125.2,67.3,124.5,69.1z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.8,69.3c-2.1-0.6-0.9,3.3-0.2,4.5c0.5,0.8,1.3,1.4,2.2,0.7C136.7,73.1,134.5,69.8,132.8,69.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.9,65.4c-0.5-0.4-2.2-1.5-2.5-0.4c-0.3,1.1,2,2,2.5,2.1c0.4,0.1,0.8-0.2,0.8-0.6 C130.6,65.9,130.2,65.6,129.9,65.4z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.4,67.4c-0.8-0.7-2.5-1-4.2,0.5c-0.8,0.7-1,1.9-0.7,2.9c0.3,1,1.3,2.1,2.4,1.9c1.4-0.2,1.6-1.8,2.3-2.7 C123,69.3,123.2,68.2,122.4,67.4z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.7,68.3c-1.1-0.4-3.8,0.2-4.1,1.3c-0.5,1.9,2.3,1.8,3.4,1.5c0.7-0.2,1.4-0.6,1.7-1.3 C114.7,69.1,114.3,68.5,113.7,68.3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.5,70.6c-2.3,0.8-2.9,2.5-2.6,3.5c0.1,0.2,0.3,0.3,0.5,0.2c1.4-0.7,2.8-1.6,2.7-3.4 C105.1,70.7,104.8,70.6,104.5,70.6z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.1,83.7c-0.5-0.9-1.6-1.4-2.4-0.5c-0.5,0.6-0.6,1.4-0.6,2.1c-0.2,0.9-0.3,1.8,0.5,2.5 c0.9,0.8,2,0,2.5-0.9C122.6,85.9,122.6,84.7,122.1,83.7z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.8,79.9c-0.9-1-2.8-0.7-3.8,1c-0.2,0.4-0.2,0.8,0.2,1.1c0.5,0.3,1.4,0,2,0c0.6-0.1,1.2-0.1,1.6-0.6 C118.1,80.9,118.2,80.3,117.8,79.9z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.9,83.5c-1.7,0.5-2.1,3-1.3,3.9c0.5,0.6,1.5,0.9,2.1,0.3c0.7-0.7,0.9-1.9,0.8-2.8 C117.4,84.2,116.8,83.3,115.9,83.5z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.1,75.3c-0.9,0-4.2,1.8-3,3.2c0.5,0.7,1.8,0.2,2.4-0.1c0.7-0.3,1.9-0.8,2.1-1.7 C111.7,75.9,110.9,75.2,110.1,75.3z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.8,76.7c-0.5,0.6,0.1,2,0.2,2.7c0.2,0.7,0.4,1.5,1.1,1.9c0.7,0.4,1.4-0.3,1.8-0.9 C134.5,78.9,132.2,74.9,130.8,76.7z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.1,76.6c-0.9,0-1.5,0.7-1.5,1.6c0,0.8,0.4,1.4,0.9,2c0.7,1.2,1.7,2.1,2.5,0.8 C128,79.5,126.9,76.7,125.1,76.6z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.9,84.9c-0.1-0.2-0.4-0.3-0.6-0.2c-0.6,0.1-0.9,0.4-1.2,0.8c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.6,0.9-1,2.5-0.4,3.5c0.7,1.3,2.1,0.4,2.6-0.6C139.6,87.6,139.6,86.1,138.9,84.9z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.4,94.9c-0.2-0.8-1.1-1-1.8-0.6c-0.8,0.4-1.6,1.3-2.1,2.1c-0.2,0.3-0.5,0.8-0.7,1.3 c-0.1,0.3-0.2,0.6-0.1,0.9c0.6,2.1,3.3-0.4,3.8-1.2C134,96.7,134.6,95.7,134.4,94.9z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.7,110.1c-0.5-1.1-2.2-2.9-3.6-2.2c-0.6,0.3-0.8,1.9,1.1,3.4c0.5,0.4,1.6,0.8,2.2,0.5 C98,111.5,97.9,110.7,97.7,110.1z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.9,108.1c-0.6-0.3-1.4-0.8-2.1-0.8c-0.6,0.1-0.9,0.7-0.7,1.2c0.2,0.4,2.7,2.6,3.6,2.2 c0.5-0.2,0.9-0.9,0.8-1.5C103.2,108.5,102.4,108.3,101.9,108.1z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.9,100.1c-0.8-0.1-1.6,0.3-2.2,0.8c-0.7,0.5-1.6,1.3-1.7,2.2c0,0.2,0,0.3,0,0.5c0,0.4,0.2,0.8,0.7,1.1 c1.4,1.1,3.3,0.7,4.1-0.8C101.5,102.6,101.7,100.4,99.9,100.1z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.3,97.3c-0.9-0.7-1.9-0.1-2.4,0.7c-0.5,0.9-0.6,2.1-0.1,3c0,0.1,0,0.1,0,0.2c0.3,0.7,1,2.1,1.9,2.2 c1.1,0.1,1.4-1.6,1.5-2.4C94.3,99.9,94.3,98.2,93.3,97.3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M111.7,103.5c-0.8,0.2-1.6,0.5-2.4,0.8c-0.4,0.1-0.8,0.1-1.3,0.2c-0.8,0.1-1.8,0-2.5,0.3 c-1,0.3-0.8,1.3,0,1.7c2,1.2,6.6,0.4,6.9-2.3C112.4,103.8,112.1,103.4,111.7,103.5z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.6,100.8c-0.4-0.3-1-0.5-1.4-0.1c-0.2,0.2-0.3,0.5-0.4,0.9c-0.2,0.3-0.2,0.7-0.1,1.1 c0.1,0.5,0.4,1,0.9,1.2c1.2,0.5,2-0.5,1.8-1.6C105.2,101.7,105,101.1,104.6,100.8z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.9,76.7c-0.5,0-1,0.5-1.5,0.9c-1,0.5-1.7,1.7-1.8,2.7c0,0.6,0.1,1.4,0.9,1.4c0.4,0,0.7-0.3,1-0.5 c0.4-0.3,0.8-0.7,1.2-1.1c0.5-0.5,1.1-1.2,1.1-1.9C101.9,77.4,101.6,76.7,100.9,76.7z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.2,88.5c-0.6,0.3-1,0.8-1.1,1.5c-0.6,1-0.6,2.3,0,3.3c1,1.6,2.3,0,2.5-1.3C99.8,91.3,99.9,87.9,98.2,88.5 z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.6,97.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.2c-0.6,0.2-1.2,0.4-1.7,0.7 c-0.7,0.5-0.9,1.7,0,2.1c0.9,0.5,2.3,0,3.1-0.5c0.8-0.4,1.9-1.4,1.7-2.4C124.6,96.3,123.3,96.8,122.6,97.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.6,85.7c-0.4,0.2-0.5,3,0.1,3.3c1,0.4,1.6-1,1.6-1.8C131.3,86.3,130.6,85.1,129.6,85.7z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.4,91.2c-0.6,0-2.7,0.6-2,2.6c0.3,1,2,0.2,2.4-0.4C130.3,92.8,130.6,91.3,129.4,91.2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.5,105.2c-1-0.7-2.4,0.2-3.1,1c-0.1,0.2-0.1,0.4-0.1,0.5c0,1,1.8,1.1,2.5,0.9c0.5-0.2,1.1-0.5,1.2-1.1 C119.2,106,118.9,105.5,118.5,105.2z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.5,90.5c-0.4-0.7-1.3-0.5-1.8,0.1c-0.4,0.6-0.6,1.4-0.4,2c0.1,0.2,0.2,0.4,0.3,0.5 c0.2,0.4,0.5,0.6,0.9,0.7c0.7,0.1,1.1-0.5,1.1-1.1c0.1-0.4,0-0.9,0-1.3C94.7,91.1,94.6,90.8,94.5,90.5z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.2,94.2c-0.2-0.6-0.6-1.2-1.3-1c-0.5,0.2-1.4,2-0.3,4.2c0.3,0.5,0.8,1.1,1.4,1c0.7-0.1,0.8-0.7,0.7-1.3 C103.4,96.2,103.5,95.1,103.2,94.2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.8,82.2c-0.5-0.2-1.2-0.1-1.8,0.3c-0.6,0.3-1.2,0.8-1.4,1.4c-0.5,1.8,1.9,1.4,2.9,1 c0.5-0.2,1.1-0.6,1.3-1.2C109.9,83,109.4,82.4,108.8,82.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.9,93.1c-0.3-0.4-0.6-0.9-1-1.3c-0.5-0.5-1.4-0.8-2-0.2c-0.6,0.6,0.3,3.5,2.3,4.1 c0.8,0.2,1.3-0.7,1.2-1.5C111.3,93.8,111.1,93.5,110.9,93.1z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M119.5,91.8c-0.4,0.2-1.9,1.1-2.2,1.4c-0.5,0.5-0.5,1.2,0,1.7c1.1,0.9,3.1-0.3,3.5-1.5 C121,92.8,121.6,90.7,119.5,91.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.5868,
    y1: 44.5039,
    x2: 143.0414,
    y2: 44.5039,
    gradientTransform: "matrix(0.9915 -0.1298 0.1298 0.9915 -41.9635 44.6615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M103.8,67c-3.1,1.9-5.6,6-6,7.4c-0.6,2.1,2.6-1.6,3.3-2.4c1.3-1.5,2.6-3,3.9-4.5 C105.3,67.1,105.5,66,103.8,67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.3836,
    y1: 55.6161,
    x2: 133.7445,
    y2: 55.6161,
    gradientTransform: "matrix(0.9915 -0.1298 0.1298 0.9915 -41.9635 44.6615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M96.5,76.6c-1.8,2.6-3.5,5.6-4.5,8.7c-0.3,0.8-0.5,1.5-0.6,2.3c0,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.2,0.1,0.2 c0,0.3,0,0.6,0.1,0.9c0,0.2,0.3,0.2,0.4,0c1-2.2,1.9-4.5,2.9-6.7c0.9-1.9,2.1-3.7,2.5-5.7C97.2,76.5,96.7,76.3,96.5,76.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.7397,
    y1: 79.9287,
    x2: 166.0232,
    y2: 79.9287,
    gradientTransform: "matrix(0.9915 -0.1298 0.1298 0.9915 -41.9635 44.6615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M132.2,100.1c-1,0.4-1.7,1.2-2.5,1.9c-1.1,0.6-2.2,1.2-3.2,2c-0.7,0.5-0.7,1.2,0.2,1.5 c1.1,0.4,2.8-1,3.7-1.6c1.2-0.8,2.3-1.8,2.4-3.3C132.8,100.2,132.5,100,132.2,100.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.5255,
    y1: 54.5097,
    x2: 130.7165,
    y2: 90.552,
    gradientTransform: "matrix(0.9915 -0.1298 0.1298 0.9915 -41.9635 44.6615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M101.8,115.7c-3.5-0.2-7-1-9.9-3c-2.5-1.8-3.7-4.9-4.5-7.9c-0.6-3.8,0-7.9,0.7-11 c1.7-7.8,5.5-15.7,9.4-22.2c-4.2,4.1-9.8,17.6-10.9,26.4c-0.2,1.3-0.7,5.9,0.4,9c1.4,4.2,4.6,7.5,6.9,8.2 c1.6,0.8,3.4,1.2,5.2,1.5c8.4,1.1,19.2-2.7,26.3-7C122.6,110.7,109.8,116.1,101.8,115.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.647,
    y1: 395.462,
    x2: 89.5265,
    y2: 338.221,
    gradientTransform: "matrix(0.7801 -0.6256 0.6256 0.7801 -227.6329 -66.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M67.5,138.4c-12.5-0.4-24.7,7.7-26.9,20.5c-1,5.8-0.3,11.1,3,15.9c2.5,3.6,5.9,7.4,8.2,8.7 c11.4,6.7,27.7,4.8,39,0.5c5.5-2.1,11.6-5.6,13.2-12c1.3-5-2.7-10.5-5.5-14.5C91.6,147.3,80.3,138.8,67.5,138.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.2116,
    y1: 353.5386,
    x2: 95.3634,
    y2: 353.5386,
    gradientTransform: "matrix(0.7801 -0.6256 0.6256 0.7801 -227.6329 -66.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.7,143.7c-2.6-1.2-13.3,1.2-17,12.2c-2.3,6.8,0.2,13.4,4.7,18.3c2.7,2.9,5.5,1.3,6-0.9 c1.4-6.2,3.2-11.9,6-17.6C64,152.5,67.4,145.9,62.7,143.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.0908,
    y1: 374.8583,
    x2: 111.6457,
    y2: 374.8583,
    gradientTransform: "matrix(0.7801 -0.6256 0.6256 0.7801 -227.6329 -66.6295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M92.6,154.4c-2.7-2.7-5.8-4.8-9.1-6.8c-4-2.5-4.3-0.3-3.1,2.9c0.5,1.2,1,6.2,1.1,7.4 c0.4,3.4-0.2,7,0.4,10.4c0.8,4.5,4.5,9.6,9.8,8.4c6.1-1.4,7.9-7.3,6.6-12.3C97.6,161.3,94.9,156.7,92.6,154.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.1895,
    y1: 163.2408,
    x2: 128.8384,
    y2: 163.2408,
    gradientTransform: "matrix(-0.2571 -0.9664 0.9664 -0.2571 -55.3407 309.2211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M77.9,140.4c4.7,2.6,14.7,9.6,20.2,17.4c3.5,5.1,5.8,12.1,4.3,15.5c-1.6,3.4-4.6,11-28.1,13.5 c-7.7,0.9-18.1-1.1-23.6-4.4c6.2,5.5,15.3,6.8,24.3,6.4c8.8-0.4,16.6-2.1,24.3-7.3c4.7-3.1,9.7-11.2,2.2-22.7 C92.7,145.5,81.9,141.6,77.9,140.4z"
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89,155.5c0.7,1,1.5,2.1,2.4,3c0.4,0.5,1,1.2,1.7,0.7c0.6-0.6,0.7-3.7-3-4.8C88.8,154.1,88.4,154.7,89,155.5 z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.2,167.5c-0.3,0.7,0.8,3.2,2.1,4.8c0.3,0.4,0.9,0.1,1-0.4c0.1-0.3-0.1-0.7-0.2-0.9 c-0.2-0.6-0.4-1.2-0.7-1.8c-0.2-0.6-0.5-1.8-1.2-2.1C43.8,166.8,43.4,167,43.2,167.5z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.6,176.8c0.1,0.7,2.7,3.4,3.6,3.2c1.8-0.4-0.6-2.8-1.1-3.4c-0.5-0.5-1-1.2-1.8-1 C48.8,175.8,48.5,176.3,48.6,176.8z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.2,163.7c0.8-0.1,1-1.2,1.1-1.8c0.1-0.7,0.4-1.7,0-2.4c-0.4-0.6-1.2-0.6-1.7-0.2 C46.4,160.1,46.2,163.9,48.2,163.7z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.6,156.2c0.4,2.1,3.3-0.8,4.1-1.9c0.5-0.8,0.6-1.8-0.4-2.3C46.2,151.1,44.2,154.5,44.6,156.2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.4,160.7c-0.1,0.6-0.3,2.7,0.8,2.4c1.1-0.3,0.8-2.6,0.7-3.2c-0.1-0.4-0.5-0.6-0.9-0.4 C42.6,159.8,42.5,160.3,42.4,160.7z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.7,166.4c-0.3,1,0.2,2.6,2.3,3.5c1,0.4,2.2,0,2.9-0.8c0.7-0.7,1.2-2.1,0.6-3.1c-0.8-1.1-2.3-0.6-3.4-0.8 C49,165,48,165.2,47.7,166.4z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.5,173.7c0.1,1.1,2,3.3,3.1,3.1c1.9-0.4,0.5-2.9-0.2-3.7c-0.5-0.5-1.2-1-1.9-0.9 C52.7,172.4,52.4,173,52.5,173.7z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.8,180.8c1.7,1.7,3.5,1.4,4.3,0.7c0.1-0.1,0.1-0.4,0-0.5c-1.2-0.9-2.8-1.8-4.2-0.8 C58.5,180.2,58.6,180.6,58.8,180.8z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.3,159.2c-0.5,0.9-0.5,2.1,0.7,2.3c0.7,0.2,1.5-0.1,2.2-0.4c0.9-0.2,1.7-0.6,2-1.6 c0.2-1.2-0.9-1.8-1.9-1.8C64,157.7,62.9,158.2,62.3,159.2z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.9,164.7c-0.5,1.3,0.7,2.8,2.6,3c0.4,0,0.8-0.2,0.9-0.7c0-0.6-0.7-1.3-1-1.8c-0.3-0.5-0.7-1-1.3-1.2 C61.6,164,61.1,164.2,60.9,164.7z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65,164.7c1.3,1.3,3.6,0.5,4.1-0.6c0.3-0.7,0.2-1.8-0.7-2c-0.9-0.3-2.1,0-2.9,0.6 C64.9,163.1,64.3,164.1,65,164.7z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.3,173.7c0.4,0.8,3.5,2.9,4.2,1.2c0.3-0.8-0.7-1.6-1.2-2.1c-0.6-0.5-1.6-1.3-2.4-1.1 C60.1,172,59.9,173,60.3,173.7z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.1,154.7c0.7,0.2,1.7-1,2.3-1.4c0.5-0.5,1.1-1,1.2-1.8c0-0.9-0.9-1.1-1.6-1.1 C52.3,150.3,49.8,154.2,52.1,154.7z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.6,159.7c0.4,0.8,1.3,1,2.1,0.6c0.7-0.4,1.1-1,1.3-1.8c0.7-1.2,1.1-2.5-0.5-2.6 C55.9,155.9,53.9,158.1,54.6,159.7z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.6,143.7c-0.1,0.2-0.1,0.5,0.1,0.6c0.3,0.5,0.7,0.7,1.2,0.7c0.2,0,0.4,0.1,0.5,0.1c1,0.1,2.7-0.3,3.3-1.2 c0.8-1.2-0.6-2-1.7-2C57.7,141.8,56.4,142.5,55.6,143.7z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.5,143.1c-0.6,0.6-0.3,1.5,0.3,1.9c0.8,0.5,1.9,0.8,2.8,0.9c0.4,0,1,0.1,1.5,0.1c0.3,0,0.6-0.1,0.8-0.4 c1.6-1.5-1.8-2.7-2.8-2.9C68.3,142.6,67.2,142.5,66.5,143.1z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97,168.7c-0.8,1-1.5,3.3-0.3,4.2c0.6,0.4,2.1-0.2,2.5-2.5c0.1-0.6,0-1.8-0.6-2.2 C98,167.8,97.4,168.2,97,168.7z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.2,165.9c0,0.7-0.1,1.7,0.3,2.3c0.3,0.5,1,0.5,1.4,0c0.3-0.3,1.1-3.6,0.2-4.2c-0.5-0.4-1.2-0.4-1.6,0 C93,164.5,93.2,165.3,93.2,165.9z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M87.1,171.4c0.3,0.8,1,1.3,1.7,1.6c0.8,0.3,1.8,0.8,2.7,0.5c0.2-0.1,0.3-0.1,0.4-0.2 c0.3-0.2,0.6-0.5,0.7-1.1c0.3-1.8-0.8-3.2-2.6-3.3C88.5,168.7,86.5,169.6,87.1,171.4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.6,178.4c-0.3,1.1,0.7,1.8,1.7,1.8c1,0,2.1-0.5,2.7-1.3c0,0,0.1-0.1,0.2-0.1c0.5-0.6,1.5-1.8,1.1-2.7 c-0.4-1-2.1-0.5-2.8-0.2C89.4,176.4,87.9,177.2,87.6,178.4z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.6,159.3c0.5,0.6,1.2,1.2,1.8,1.8c0.3,0.3,0.5,0.7,0.8,1c0.4,0.7,0.8,1.6,1.4,2.1 c0.7,0.7,1.5,0.1,1.6-0.8c0.2-2.3-2.7-6-5.2-5.1C84.6,158.5,84.4,159,84.6,159.3z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.5,166.8c-0.1,0.5,0,1.1,0.5,1.3c0.3,0.1,0.6,0.1,1,0c0.4,0.1,0.7-0.2,1-0.4c0.4-0.3,0.7-0.8,0.7-1.4 c-0.1-1.3-1.4-1.5-2.3-0.8C86,165.9,85.6,166.3,85.5,166.8z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.9,181.2c0.2,0.4,0.9,0.7,1.4,0.9c0.9,0.6,2.3,0.7,3.2,0.3c0.5-0.2,1.1-0.8,0.8-1.4 c-0.2-0.4-0.6-0.5-1-0.7c-0.5-0.2-1-0.4-1.5-0.6c-0.7-0.2-1.5-0.4-2.2-0.1C66,179.9,65.5,180.6,65.9,181.2z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.5,178.1c0.5,0.4,1.2,0.5,1.9,0.3c1.2,0,2.3-0.5,2.9-1.5c1-1.6-1.1-2-2.3-1.7 C79.2,175.4,76.2,177,77.5,178.1z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74,152.5c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.4,0.9,0.9,1.4,1.2c0.8,0.4,1.9,0,1.9-1 c0-1-1.1-2.1-1.9-2.6c-0.7-0.5-2.1-1.1-2.9-0.4C72.3,151.1,73.3,152.1,74,152.5z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.6,151.6c0.4,0.2,2.9-0.9,2.9-1.6c-0.1-1.1-1.7-0.9-2.3-0.6C60.4,149.8,59.6,151,60.6,151.6z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.6,149.2c0.3,0.6,1.8,2.2,3.3,0.6c0.7-0.8-0.7-1.8-1.5-2C66.6,147.7,65.1,148.1,65.6,149.2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83,152.5c-0.1,1.2,1.3,2.1,2.3,2.3c0.2,0,0.4,0,0.5-0.2c0.9-0.4,0.1-2.1-0.4-2.6c-0.4-0.4-0.9-0.7-1.5-0.6 C83.4,151.5,83.1,152,83,152.5z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.1,180.5c-0.4,0.7,0.2,1.4,0.9,1.5c0.7,0.1,1.5-0.1,2-0.6c0.1-0.1,0.2-0.3,0.3-0.5 c0.2-0.3,0.3-0.7,0.2-1.1c-0.2-0.6-0.9-0.7-1.5-0.5c-0.4,0.1-0.8,0.4-1.2,0.6C81.5,180.1,81.2,180.2,81.1,180.5z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.3,171.1c-0.4,0.4-0.8,1.1-0.3,1.6c0.4,0.3,2.4,0.3,3.9-1.6c0.4-0.5,0.6-1.2,0.2-1.7 c-0.4-0.6-1-0.4-1.5,0C81.9,170,81,170.4,80.3,171.1z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.1,171.6c0.1,0.5,0.5,1.1,1.1,1.5c0.5,0.4,1.3,0.7,1.8,0.6c1.8-0.4,0.4-2.4-0.4-3 c-0.5-0.4-1.1-0.7-1.7-0.5C67.3,170.3,67,171,67.1,171.6z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.8,164.8c-0.2,0.5-0.5,0.9-0.7,1.4c-0.2,0.7-0.1,1.6,0.7,1.8c0.8,0.2,3-1.9,2.6-3.9 c-0.2-0.8-1.2-0.9-1.9-0.4C76.2,164,76,164.4,75.8,164.8z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.6,157.7c0.4,0.2,1.8,1.2,2.2,1.3c0.6,0.2,1.4-0.1,1.5-0.8c0.3-1.4-1.7-2.6-2.9-2.4 C70.8,155.9,68.7,156.3,70.6,157.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.809,
    y1: 109.2422,
    x2: 116.2628,
    y2: 109.2422,
    gradientTransform: "matrix(-0.5714 -0.8207 0.8207 -0.5714 34.6585 337.7995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M55.8,183.1c3.1,1.9,7.9,2.2,9.3,2c2.2-0.4-2.6-1.6-3.7-1.8c-1.9-0.5-3.8-1-5.8-1.4 C55.3,181.7,54.2,182.1,55.8,183.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.6067,
    y1: 120.354,
    x2: 106.9668,
    y2: 120.354,
    gradientTransform: "matrix(-0.5714 -0.8207 0.8207 -0.5714 34.6585 337.7995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M67.8,185.2c3.2,0.4,6.6,0.5,9.9,0c0.8-0.1,1.6-0.2,2.3-0.5c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.1-0.1,0.2-0.2 c0.3-0.1,0.5-0.3,0.7-0.5c0.1-0.1,0.1-0.4-0.1-0.3c-2.4,0.1-4.9,0.4-7.3,0.5c-2.1,0.1-4.2-0.2-6.2,0.4 C67.4,184.6,67.4,185.1,67.8,185.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.9615,
    y1: 144.664,
    x2: 139.2443,
    y2: 144.664,
    gradientTransform: "matrix(-0.5714 -0.8207 0.8207 -0.5714 34.6585 337.7995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M72.2,142.6c0.8,0.7,1.9,0.9,2.8,1.3c1.1,0.7,2.1,1.4,3.2,1.9c0.7,0.4,1.4,0.1,1.3-0.8 c-0.2-1.2-2.2-2.1-3.1-2.5c-1.3-0.7-2.6-1.2-4-0.6C72,142,71.9,142.4,72.2,142.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.7471,
    y1: 119.2478,
    x2: 103.9396,
    y2: 155.2874,
    gradientTransform: "matrix(-0.5714 -0.8207 0.8207 -0.5714 34.6585 337.7995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M100,162.4c1.4,3.2,2.4,6.7,1.9,10.2c-0.4,3-2.6,5.5-4.9,7.6c-3.1,2.2-7,3.6-10.1,4.4 c-7.7,2-16.4,2.4-24,1.9c5.6,1.9,20.2,0.6,28.4-2.5c1.2-0.5,5.5-2.1,7.8-4.4c3.1-3.1,4.5-7.5,4.1-9.9c-0.1-1.8-0.5-3.6-1.1-5.3 c-2.9-8-11.2-15.8-18.3-20.1C86,146.2,96.7,155.2,100,162.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.0797,
    y1: 471.0883,
    x2: 78.959,
    y2: 413.8504,
    gradientTransform: "matrix(-0.6519 -0.7583 0.7583 -0.6519 -182.0617 575.0723)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M77,231.8c0.1,12.5,8.6,24.4,21.4,26.2c5.8,0.8,11.1-0.1,15.8-3.6c3.5-2.6,7.2-6.1,8.4-8.5 c6.3-11.6,3.9-27.9-0.8-39c-2.3-5.4-6-11.4-12.4-12.8c-5-1.1-10.4,3-14.3,5.9C85.1,207.4,76.9,219,77,231.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.6441,
    y1: 429.168,
    x2: 84.7941,
    y2: 429.168,
    gradientTransform: "matrix(-0.6519 -0.7583 0.7583 -0.6519 -182.0617 575.0723)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M82.5,236.5c-1.1,2.7,1.6,13.2,12.7,16.5c6.9,2.1,13.4-0.7,18.1-5.3c2.8-2.8,1.1-5.6-1.1-6 c-6.2-1.2-12-2.8-17.8-5.4C91.2,234.8,84.5,231.6,82.5,236.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.5242,
    y1: 450.485,
    x2: 101.078,
    y2: 450.485,
    gradientTransform: "matrix(-0.6519 -0.7583 0.7583 -0.6519 -182.0617 575.0723)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M92.2,206.2c-2.6,2.8-4.6,6-6.5,9.3c-2.3,4.1-0.2,4.3,3,3c1.2-0.5,6.1-1.2,7.4-1.4c3.4-0.5,7,0,10.4-0.8 c4.5-1,9.5-4.9,8.1-10c-1.6-6.1-7.6-7.7-12.5-6.2C98.9,201,94.4,203.8,92.2,206.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.2767,
    y1: 184.2997,
    x2: 54.9275,
    y2: 184.2997,
    gradientTransform: "matrix(-0.957 0.29 -0.29 -0.957 187.3034 390.3194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M78.7,221.3c2.5-4.7,9.1-15,16.7-20.8c4.9-3.7,11.9-6.2,15.4-4.8c3.5,1.4,11.1,4.2,14.5,27.6 c1.1,7.7-0.5,18.1-3.5,23.8c5.3-6.4,6.3-15.6,5.6-24.5c-0.7-8.7-2.7-16.5-8.1-24c-3.3-4.6-11.5-9.3-22.7-1.5 C83.3,206.4,79.7,217.3,78.7,221.3z"
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.4,209.8c1-0.8,2-1.6,2.9-2.5c0.4-0.4,1.2-1.1,0.6-1.7c-0.6-0.6-3.7-0.5-4.7,3.2 C92,209.9,92.6,210.4,93.4,209.8z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.9,255.1c0.7,0.3,3.1-0.9,4.8-2.2c0.3-0.3,0-0.9-0.4-1c-0.3-0.1-0.7,0.1-0.9,0.2 c-0.6,0.2-1.2,0.5-1.8,0.7c-0.6,0.3-1.8,0.5-2.1,1.2C106.2,254.5,106.4,254.9,106.9,255.1z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116,249.4c0.7-0.1,3.3-2.8,3.1-3.7c-0.4-1.8-2.8,0.7-3.3,1.2c-0.5,0.5-1.1,1.1-0.9,1.8 C115.1,249.2,115.5,249.5,116,249.4z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103,250.2c-0.1-0.8-1.2-0.9-1.8-1c-0.7-0.1-1.8-0.3-2.4,0.1c-0.6,0.4-0.5,1.2-0.1,1.7 C99.5,252.2,103.3,252.2,103,250.2z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.6,254.1c2.1-0.5-0.9-3.3-2.1-4c-0.8-0.5-1.8-0.5-2.2,0.5C90.4,252.7,93.9,254.5,95.6,254.1z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.2,256.1c0.6,0.1,2.7,0.2,2.4-0.8c-0.3-1.1-2.7-0.7-3.2-0.6c-0.4,0.1-0.6,0.5-0.4,0.9 C99.2,256,99.7,256.1,100.2,256.1z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.7,250.7c1,0.3,2.6-0.3,3.4-2.5c0.4-1-0.1-2.2-0.9-2.9c-0.8-0.7-2.1-1.2-3.1-0.5 c-1.1,0.8-0.5,2.3-0.7,3.5C104.2,249.4,104.5,250.4,105.7,250.7z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.8,245.6c1.1-0.2,3.2-2.1,3-3.2c-0.5-1.9-2.9-0.4-3.7,0.3c-0.5,0.5-0.9,1.2-0.8,2 C111.5,245.5,112.1,245.7,112.8,245.6z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M119.7,239.1c1.7-1.8,1.3-3.6,0.5-4.3c-0.1-0.1-0.4-0.1-0.5,0.1c-0.8,1.3-1.7,2.8-0.7,4.3 C119.1,239.3,119.5,239.3,119.7,239.1z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M98,236.3c0.9,0.5,2.1,0.4,2.3-0.8c0.1-0.7-0.1-1.5-0.5-2.2c-0.2-0.9-0.7-1.7-1.6-1.9c-1.2-0.2-1.8,1-1.8,2 C96.4,234.6,97,235.8,98,236.3z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.5,237.5c1.3,0.4,2.8-0.8,2.9-2.7c0-0.4-0.2-0.8-0.7-0.8c-0.6,0-1.3,0.7-1.7,1c-0.5,0.3-1,0.7-1.1,1.3 C102.7,236.8,103,237.4,103.5,237.5z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.4,233.5c1.3-1.3,0.4-3.6-0.8-4.1c-0.7-0.3-1.8-0.1-2,0.8c-0.2,0.9,0.1,2.1,0.7,2.9 C101.8,233.6,102.8,234.1,103.4,233.5z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.5,237.8c0.8-0.5,2.8-3.6,1-4.3c-0.8-0.3-1.6,0.7-2,1.2c-0.5,0.6-1.3,1.6-1,2.5 C110.8,238.1,111.8,238.2,112.5,237.8z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.8,246.7c0.1-0.7-1-1.7-1.5-2.2c-0.5-0.5-1.1-1.1-1.8-1.1c-0.9,0-1.1,1-1.1,1.7 C89.4,246.6,93.4,249,93.8,246.7z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.8,244c0.8-0.4,0.9-1.4,0.5-2.1c-0.4-0.7-1.1-1-1.8-1.3c-1.2-0.7-2.6-1-2.6,0.6 C94.9,242.9,97.2,244.8,98.8,244z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.7,243.5c0.2,0.1,0.5,0,0.6-0.1c0.5-0.3,0.6-0.8,0.7-1.3c0-0.2,0.1-0.4,0.1-0.5c0.1-1-0.4-2.7-1.3-3.3 c-1.2-0.7-2,0.7-2,1.8C80.8,241.5,81.4,242.8,82.7,243.5z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.7,232.6c0.6,0.6,1.5,0.3,1.9-0.3c0.5-0.8,0.7-1.9,0.8-2.9c0-0.4,0.1-1,0-1.5c0-0.3-0.1-0.6-0.4-0.8 c-1.6-1.5-2.6,1.9-2.8,2.9C81.2,230.8,81.1,232,81.7,232.6z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.2,201.3c1,0.7,3.3,1.4,4.2,0.2c0.4-0.6-0.2-2.1-2.6-2.4c-0.7-0.1-1.8,0-2.2,0.7 C105.3,200.3,105.8,201,106.2,201.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.6,205.2c0.7-0.1,1.7,0,2.2-0.4c0.5-0.4,0.5-1,0-1.4c-0.3-0.3-3.6-0.9-4.2-0.1c-0.4,0.5-0.4,1.2,0.1,1.6 C102.2,205.5,103,205.2,103.6,205.2z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109.3,211.1c0.8-0.3,1.2-1,1.5-1.8c0.3-0.8,0.7-1.9,0.4-2.7c-0.1-0.2-0.2-0.3-0.3-0.4 c-0.2-0.3-0.6-0.6-1.1-0.7c-1.8-0.3-3.2,0.9-3.2,2.7C106.6,209.7,107.5,211.8,109.3,211.1z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.3,210.4c1.1,0.2,1.7-0.8,1.7-1.8c0-1-0.5-2.1-1.3-2.7c0,0-0.1-0.1-0.1-0.2c-0.6-0.5-1.9-1.4-2.7-1 c-1,0.5-0.4,2.1-0.1,2.8C114.2,208.6,115.1,210.1,116.3,210.4z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.3,214c0.6-0.6,1.2-1.2,1.7-1.9c0.3-0.3,0.7-0.5,1-0.8c0.6-0.5,1.5-0.9,2-1.5c0.7-0.8,0.1-1.5-0.9-1.5 c-2.3-0.1-5.9,2.9-4.9,5.4C96.5,214.1,97,214.3,97.3,214z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.8,212.9c0.5,0.1,1.1,0,1.3-0.5c0.1-0.3,0-0.6-0.1-1c0-0.4-0.2-0.7-0.4-1c-0.3-0.4-0.8-0.7-1.4-0.6 c-1.3,0.1-1.5,1.4-0.7,2.3C103.8,212.4,104.3,212.7,104.8,212.9z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M119.9,232c0.4-0.3,0.7-0.9,0.8-1.5c0.6-0.9,0.6-2.3,0.2-3.2c-0.2-0.5-0.8-1.1-1.4-0.8 c-0.4,0.2-0.5,0.6-0.6,1c-0.2,0.5-0.4,1-0.5,1.5c-0.2,0.7-0.4,1.5,0,2.2C118.6,231.9,119.2,232.4,119.9,232z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.4,220.4c0.4-0.5,0.4-1.2,0.3-1.9c0-1.2-0.6-2.3-1.6-2.9c-1.6-0.9-2,1.2-1.6,2.3 C113.6,218.8,115.2,221.8,116.4,220.4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M90.9,224.8c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.4,0.9-0.9,1.1-1.5 c0.4-0.8-0.1-1.9-1-1.9c-1,0-2,1.2-2.5,2c-0.4,0.7-1,2.1-0.3,2.9C89.6,226.6,90.5,225.5,90.9,224.8z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.4,238.3c0.2-0.4-1-2.9-1.7-2.8c-1.1,0.1-0.9,1.7-0.5,2.4C88.6,238.6,89.8,239.3,90.4,238.3z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.9,233.3c0.6-0.3,2.1-1.9,0.5-3.3c-0.8-0.7-1.8,0.8-1.9,1.5C86.3,232.4,86.8,233.9,87.9,233.3z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.6,215.8c1.3,0.1,2-1.4,2.2-2.4c0-0.2-0.1-0.4-0.2-0.5c-0.5-0.9-2.1,0-2.6,0.5c-0.4,0.4-0.7,1-0.5,1.5 C89.6,215.5,90.1,215.8,90.6,215.8z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.6,216.8c0.7,0.4,1.4-0.2,1.5-0.9c0.1-0.7-0.2-1.5-0.7-2c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.3-0.2-0.7-0.3-1.1-0.1c-0.6,0.3-0.7,1-0.5,1.5c0.2,0.4,0.4,0.8,0.7,1.2C118.2,216.4,118.4,216.7,118.6,216.8z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.3,217.9c0.4,0.4,1.2,0.8,1.6,0.2c0.3-0.4,0.3-2.4-1.8-3.8c-0.5-0.3-1.2-0.5-1.7-0.2 c-0.5,0.4-0.4,1,0,1.5C108.1,216.3,108.6,217.3,109.3,217.9z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.2,231.1c0.5-0.1,1.1-0.5,1.5-1.1c0.4-0.5,0.7-1.3,0.5-1.9c-0.5-1.8-2.4-0.3-3,0.5 c-0.4,0.5-0.7,1.1-0.5,1.7C108.9,230.9,109.6,231.2,110.2,231.1z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.1,222.6c0.5,0.2,1,0.5,1.5,0.7c0.7,0.2,1.6,0,1.8-0.8c0.2-0.8-2-2.9-4-2.5c-0.8,0.2-0.8,1.3-0.3,1.9 C102.3,222.2,102.7,222.4,103.1,222.6z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.2,228c0.2-0.4,1.1-1.8,1.2-2.3c0.2-0.6-0.1-1.3-0.8-1.5c-1.4-0.2-2.5,1.8-2.3,3 C94.4,227.9,94.9,230,96.2,228z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.3796,
    y1: 104.23,
    x2: 38.8342,
    y2: 104.23,
    gradientTransform: "matrix(-0.8006 0.5992 -0.5992 -0.8006 212.4243 300.1808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M122.1,241.9c1.8-3.2,2-8,1.6-9.4c-0.5-2.2-1.5,2.6-1.7,3.7c-0.4,1.9-0.8,3.9-1.2,5.8 C120.7,242.5,121.1,243.6,122.1,241.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.1762,
    y1: 115.3414,
    x2: 29.5373,
    y2: 115.3414,
    gradientTransform: "matrix(-0.8006 0.5992 -0.5992 -0.8006 212.4243 300.1808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M123.7,229.9c0.3-3.2,0.3-6.6-0.3-9.8c-0.1-0.8-0.3-1.6-0.6-2.3c0-0.2-0.1-0.3-0.1-0.5 c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.3-0.3-0.5-0.5-0.7c-0.1-0.1-0.4-0.1-0.3,0.1c0.2,2.4,0.6,4.8,0.7,7.3c0.1,2,0,4.2,0.6,6.2 C123.1,230.4,123.7,230.3,123.7,229.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.5303,
    y1: 139.6542,
    x2: 61.8136,
    y2: 139.6542,
    gradientTransform: "matrix(-0.8006 0.5992 -0.5992 -0.8006 212.4243 300.1808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M81.1,227c0.7-0.9,0.9-1.9,1.3-2.9c0.6-1.1,1.3-2.1,1.8-3.3c0.3-0.7,0-1.4-0.9-1.2c-1.2,0.3-2,2.3-2.4,3.2 c-0.6,1.3-1.1,2.7-0.5,4.1C80.5,227.2,80.9,227.2,81.1,227z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.3172,
    y1: 114.2349,
    x2: 26.5088,
    y2: 150.2761,
    gradientTransform: "matrix(-0.8006 0.5992 -0.5992 -0.8006 212.4243 300.1808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M99.9,198.5c3.1-1.5,6.6-2.6,10.1-2.3c3,0.3,5.6,2.4,7.8,4.7c2.3,3,3.9,6.9,4.8,9.9 c2.3,7.6,2.9,16.4,2.7,24c1.7-5.7-0.1-20.2-3.5-28.3c-0.5-1.2-2.3-5.4-4.7-7.6c-3.2-2.9-7.7-4.3-10.1-3.8 c-1.8,0.1-3.6,0.6-5.3,1.3c-7.9,3.1-15.4,11.7-19.5,19C84.2,213,92.8,202,99.9,198.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.8443,
    y1: 301.0328,
    x2: 118.7234,
    y2: 243.7977,
    gradientTransform: "matrix(0.7677 -0.6409 0.6409 0.7677 -71.4996 -17.7035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M189.6,90.3c-12.5-0.1-24.5,8.2-26.5,21c-0.9,5.8,0,11.1,3.3,15.8c2.5,3.6,6,7.2,8.4,8.6 c11.6,6.5,27.8,4.3,39-0.3c5.5-2.2,11.5-5.9,13-12.2c1.2-5-2.9-10.4-5.7-14.4C213.8,98.7,202.4,90.4,189.6,90.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.4103,
    y1: 259.114,
    x2: 124.5591,
    y2: 259.114,
    gradientTransform: "matrix(0.7677 -0.6409 0.6409 0.7677 -71.4996 -17.7035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M184.8,95.7c-2.7-1.2-13.2,1.4-16.7,12.5c-2.2,6.8,0.5,13.4,5.1,18.2c2.7,2.9,5.6,1.2,6-1 c1.3-6.2,2.9-12,5.6-17.7C186.3,104.5,189.6,97.8,184.8,95.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.2878,
    y1: 280.4309,
    x2: 140.8407,
    y2: 280.4309,
    gradientTransform: "matrix(0.7677 -0.6409 0.6409 0.7677 -71.4996 -17.7035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M215,105.8c-2.8-2.6-5.9-4.7-9.2-6.7c-4-2.4-4.3-0.2-3,2.9c0.5,1.2,1.1,6.1,1.3,7.4 c0.5,3.4-0.1,7,0.6,10.4c0.9,4.5,4.7,9.5,9.9,8.2c6.1-1.5,7.8-7.4,6.3-12.4C220,112.6,217.3,108,215,105.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.9644,
    y1: 153.0048,
    x2: 226.6153,
    y2: 153.0048,
    gradientTransform: "matrix(-0.2761 -0.9611 0.9611 -0.2761 106.9294 354.6429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M200,92.1c4.7,2.5,14.9,9.3,20.5,17c3.6,5,6,12,4.6,15.4c-1.5,3.5-4.3,11-27.8,14.1 c-7.7,1-18.1-0.8-23.7-3.9c6.3,5.4,15.5,6.5,24.5,6c8.7-0.5,16.5-2.4,24.2-7.7c4.6-3.2,9.5-11.4,1.8-22.7 C214.9,96.9,204,93.2,200,92.1z"
  }))), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M211.4,107c0.8,1,1.5,2,2.4,3c0.4,0.5,1.1,1.2,1.7,0.6c0.6-0.6,0.6-3.7-3.1-4.7 C211.2,105.6,210.7,106.1,211.4,107z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.8,119.8c-0.3,0.7,0.9,3.1,2.2,4.8c0.3,0.4,0.9,0,1-0.4c0.1-0.3-0.1-0.7-0.2-0.9 c-0.2-0.6-0.5-1.2-0.7-1.8c-0.3-0.6-0.5-1.8-1.2-2.1C166.4,119.2,166,119.4,165.8,119.8z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.4,129.1c0.1,0.7,2.8,3.4,3.7,3.2c1.8-0.4-0.7-2.8-1.2-3.3c-0.5-0.5-1-1.1-1.8-0.9 C171.6,128.1,171.3,128.6,171.4,129.1z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.7,116c0.8-0.1,0.9-1.2,1.1-1.8c0.1-0.7,0.3-1.8-0.1-2.4c-0.4-0.6-1.2-0.5-1.7-0.1 C168.9,112.4,168.8,116.3,170.7,116z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.9,108.6c0.5,2.1,3.3-0.8,4-2c0.5-0.8,0.5-1.8-0.4-2.2C168.4,103.4,166.6,106.9,166.9,108.6z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.9,113.1c-0.1,0.6-0.2,2.7,0.8,2.4c1.1-0.3,0.8-2.7,0.6-3.2c-0.1-0.4-0.5-0.6-0.9-0.4 C165,112.1,165,112.7,164.9,113.1z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.2,118.7c-0.3,1,0.3,2.6,2.4,3.4c1,0.4,2.2,0,2.9-0.8c0.7-0.8,1.2-2.1,0.5-3.1c-0.8-1.1-2.3-0.5-3.4-0.8 C171.6,117.2,170.6,117.5,170.2,118.7z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.2,125.9c0.2,1.1,2,3.3,3.1,3c1.9-0.4,0.5-2.9-0.3-3.7c-0.5-0.5-1.2-1-2-0.8 C175.4,124.6,175.1,125.2,175.2,125.9z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M181.7,132.8c1.8,1.7,3.6,1.4,4.3,0.6c0.1-0.1,0.1-0.4-0.1-0.5c-1.3-0.9-2.8-1.7-4.2-0.8 C181.4,132.3,181.5,132.7,181.7,132.8z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.7,111.2c-0.5,0.9-0.4,2.1,0.7,2.3c0.7,0.1,1.5-0.1,2.2-0.5c0.9-0.2,1.7-0.6,1.9-1.6 c0.2-1.2-0.9-1.8-2-1.8C186.5,109.6,185.3,110.2,184.7,111.2z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.5,116.7c-0.4,1.3,0.7,2.8,2.7,2.9c0.4,0,0.8-0.2,0.8-0.7c0-0.6-0.7-1.3-1-1.7c-0.3-0.5-0.7-1-1.3-1.1 C184.2,116,183.6,116.2,183.5,116.7z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.5,116.7c1.3,1.3,3.6,0.5,4.1-0.7c0.3-0.7,0.1-1.8-0.7-2c-0.9-0.3-2.1,0.1-2.9,0.6 C187.4,115.1,186.9,116,187.5,116.7z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183,125.7c0.5,0.8,3.6,2.9,4.3,1.1c0.3-0.8-0.7-1.6-1.2-2.1c-0.6-0.5-1.6-1.3-2.4-1 C182.8,124,182.6,125,183,125.7z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M174.4,106.9c0.7,0.1,1.7-1,2.2-1.5c0.5-0.5,1.1-1.1,1.1-1.8c0-0.9-1-1.1-1.7-1.1 C174.6,102.5,172.1,106.4,174.4,106.9z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177,111.9c0.4,0.8,1.3,1,2.1,0.5c0.7-0.4,1.1-1.1,1.3-1.8c0.7-1.2,1.1-2.5-0.6-2.6 C178.2,108,176.3,110.3,177,111.9z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.8,95.8c-0.1,0.2,0,0.5,0.1,0.6c0.3,0.5,0.8,0.7,1.3,0.7c0.2,0,0.4,0.1,0.5,0.1c1,0.1,2.7-0.4,3.3-1.3 c0.8-1.2-0.7-2-1.7-2C179.8,93.9,178.5,94.6,177.8,95.8z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M188.7,95c-0.6,0.6-0.3,1.5,0.3,1.9c0.8,0.5,1.9,0.8,2.9,0.9c0.4,0,1,0.1,1.5,0c0.3,0,0.6-0.1,0.8-0.4 c1.6-1.5-1.9-2.7-2.9-2.8C190.5,94.5,189.3,94.4,188.7,95z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M219.6,120c-0.7,1-1.5,3.3-0.2,4.2c0.6,0.4,2.1-0.2,2.5-2.5c0.1-0.6,0-1.8-0.6-2.2 C220.6,119,220,119.5,219.6,120z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M215.8,117.3c0.1,0.7-0.1,1.7,0.4,2.2c0.4,0.5,1,0.5,1.4,0c0.3-0.3,1-3.6,0.2-4.2c-0.5-0.4-1.2-0.4-1.6,0 C215.5,115.9,215.7,116.7,215.8,117.3z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209.7,122.9c0.3,0.8,1,1.2,1.7,1.6c0.8,0.3,1.9,0.8,2.7,0.4c0.2-0.1,0.3-0.1,0.4-0.3 c0.3-0.2,0.6-0.5,0.7-1.1c0.3-1.8-0.9-3.2-2.7-3.3C211.2,120.2,209.1,121.1,209.7,122.9z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210.4,129.9c-0.2,1.1,0.8,1.7,1.8,1.7c1,0,2.1-0.5,2.7-1.3c0,0,0.1-0.1,0.2-0.1c0.5-0.6,1.4-1.9,1-2.7 c-0.5-1-2.1-0.5-2.8-0.2C212.2,127.8,210.7,128.6,210.4,129.9z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.1,110.9c0.6,0.6,1.2,1.2,1.9,1.8c0.3,0.3,0.5,0.7,0.8,1c0.5,0.7,0.9,1.5,1.5,2.1 c0.8,0.7,1.5,0.1,1.5-0.8c0.1-2.3-2.8-6-5.3-5C207,110.1,206.8,110.6,207.1,110.9z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M208.1,118.4c-0.1,0.5,0,1.1,0.5,1.3c0.3,0.1,0.6,0.1,1-0.1c0.4,0,0.7-0.2,1-0.4c0.4-0.3,0.7-0.8,0.6-1.4 c-0.1-1.3-1.4-1.5-2.3-0.8C208.6,117.4,208.2,117.8,208.1,118.4z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.7,133.1c0.3,0.4,0.9,0.7,1.4,0.9c0.9,0.6,2.3,0.7,3.2,0.3c0.5-0.2,1.1-0.8,0.8-1.4 c-0.2-0.4-0.6-0.5-1-0.6c-0.5-0.2-1-0.4-1.5-0.5c-0.7-0.2-1.5-0.4-2.2-0.1C188.9,131.8,188.4,132.5,188.7,133.1z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.4,129.8c0.5,0.4,1.2,0.5,1.9,0.3c1.2,0,2.3-0.6,2.9-1.6c0.9-1.6-1.1-2-2.3-1.6 C202,127.1,199,128.7,200.4,129.8z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M196.3,104.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.4,0.9,0.9,1.4,1.1c0.8,0.4,1.9,0,1.9-1 c0-1-1.1-2-1.9-2.5c-0.7-0.5-2.1-1-2.9-0.3C194.6,102.9,195.6,103.8,196.3,104.3z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.9,103.6c0.4,0.2,2.9-1,2.8-1.7c-0.1-1.1-1.7-0.9-2.4-0.5C182.6,101.8,181.9,103,182.9,103.6z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.9,101.1c0.3,0.6,1.8,2.1,3.3,0.5c0.7-0.8-0.8-1.8-1.5-2C188.8,99.6,187.3,100.1,187.9,101.1z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.3,104.1c-0.1,1.2,1.3,2,2.4,2.3c0.2,0,0.4,0,0.5-0.2c0.9-0.5,0.1-2.1-0.4-2.6c-0.4-0.4-1-0.7-1.5-0.6 C205.7,103.1,205.4,103.6,205.3,104.1z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203.9,132.1c-0.4,0.7,0.2,1.4,0.9,1.5c0.7,0.1,1.5-0.1,2-0.6c0.1-0.1,0.2-0.3,0.3-0.5 c0.2-0.3,0.3-0.7,0.2-1.1c-0.3-0.6-0.9-0.7-1.5-0.5c-0.4,0.2-0.8,0.4-1.2,0.6C204.3,131.7,204.1,131.9,203.9,132.1z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203,122.7c-0.4,0.4-0.8,1.2-0.2,1.6c0.4,0.3,2.4,0.3,3.8-1.7c0.3-0.5,0.6-1.2,0.2-1.7c-0.4-0.6-1-0.4-1.5,0 C204.6,121.6,203.6,122,203,122.7z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M189.8,123.5c0.1,0.5,0.5,1.1,1.1,1.5c0.5,0.4,1.3,0.7,1.9,0.6c1.8-0.4,0.4-2.4-0.4-3 c-0.5-0.4-1.1-0.7-1.7-0.5C190,122.2,189.7,122.9,189.8,123.5z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.4,116.5c-0.2,0.5-0.5,1-0.7,1.5c-0.2,0.7,0,1.6,0.8,1.8c0.8,0.2,3-2,2.5-3.9c-0.2-0.8-1.3-0.8-1.9-0.4 C198.8,115.8,198.6,116.1,198.4,116.5z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M193.1,109.5c0.4,0.2,1.8,1.1,2.3,1.3c0.6,0.2,1.4-0.1,1.5-0.8c0.2-1.4-1.7-2.5-3-2.3 C193.2,107.8,191.1,108.2,193.1,109.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.8647,
    y1: 133.3751,
    x2: 211.3194,
    y2: 133.3751,
    gradientTransform: "matrix(-0.5875 -0.8092 0.8092 -0.5875 196.963 381.3927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M178.8,135.2c3.2,1.8,8,2.1,9.3,1.8c2.2-0.5-2.6-1.5-3.7-1.8c-1.9-0.4-3.9-0.9-5.8-1.3 C178.2,133.8,177.1,134.2,178.8,135.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.6613,
    y1: 144.4868,
    x2: 202.0225,
    y2: 144.4868,
    gradientTransform: "matrix(-0.5875 -0.8092 0.8092 -0.5875 196.963 381.3927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M190.7,137c3.2,0.3,6.6,0.4,9.9-0.2c0.8-0.1,1.6-0.3,2.3-0.6c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.1-0.1,0.2-0.2 c0.3-0.1,0.5-0.3,0.7-0.5c0.1-0.1,0.1-0.4-0.1-0.3c-2.4,0.2-4.8,0.5-7.3,0.6c-2.1,0.1-4.2-0.1-6.2,0.5 C190.3,136.4,190.4,137,190.7,137z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.0163,
    y1: 168.7998,
    x2: 234.2996,
    y2: 168.7998,
    gradientTransform: "matrix(-0.5875 -0.8092 0.8092 -0.5875 196.963 381.3927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M194.3,94.4c0.8,0.7,1.9,0.9,2.9,1.3c1.1,0.6,2.1,1.3,3.3,1.9c0.7,0.3,1.4,0,1.2-0.9 c-0.2-1.2-2.2-2-3.2-2.5c-1.3-0.7-2.7-1.1-4.1-0.5C194.1,93.8,194.1,94.2,194.3,94.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.8029,
    y1: 143.3803,
    x2: 198.994,
    y2: 179.4222,
    gradientTransform: "matrix(-0.5875 -0.8092 0.8092 -0.5875 196.963 381.3927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M222.5,113.7c1.5,3.1,2.5,6.6,2.1,10.1c-0.3,3-2.5,5.6-4.8,7.7c-3,2.3-7,3.8-10,4.6 c-7.6,2.2-16.4,2.7-24,2.3c5.6,1.8,20.2,0.2,28.4-3.1c1.2-0.5,5.5-2.2,7.7-4.6c3-3.2,4.4-7.6,3.9-10c-0.1-1.8-0.6-3.6-1.2-5.3 c-3-7.9-11.5-15.6-18.7-19.7C208.2,97.8,219.1,106.5,222.5,113.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.239,
    y1: 244.3286,
    x2: 118.1183,
    y2: 187.0907,
    gradientTransform: "matrix(0.1029 0.9947 -0.9947 0.1029 464.2937 -12.0237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2A3B"
    }
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M285.3,137.8c7.1-10.3,6.9-24.9-2.7-33.7c-4.3-4-9.2-6.2-15-6.1c-4.4,0.1-9.4,1-11.8,2.2 c-11.9,5.9-19.1,20.7-21.6,32.5c-1.2,5.8-1.5,12.8,2.9,17.6c3.5,3.8,10.3,3.4,15.2,3.3C264.7,153.2,278,148.4,285.3,137.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.8041,
    y1: 202.4078,
    x2: 123.9543,
    y2: 202.4078,
    gradientTransform: "matrix(0.1029 0.9947 -0.9947 0.1029 464.2937 -12.0237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M283.4,130.8c2.5-1.6,6.2-11.8-1-20.8c-4.5-5.6-11.4-7.1-17.9-6c-3.9,0.7-4.1,4-2.5,5.5 c4.4,4.5,8.3,9.1,11.5,14.6C275.3,127.2,279,133.6,283.4,130.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.6829,
    y1: 223.7256,
    x2: 140.2368,
    y2: 223.7256,
    gradientTransform: "matrix(0.1029 0.9947 -0.9947 0.1029 464.2937 -12.0237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M258.2,150.2c3.7-0.9,7.2-2.3,10.7-3.9c4.2-2,2.6-3.5-0.8-4.1c-1.2-0.2-5.7-2.5-6.8-3.1 c-3.1-1.5-5.7-3.9-9-5.3c-4.3-1.8-10.5-1.4-12.4,3.6c-2.1,5.9,1.8,10.6,6.8,12.2C249.8,150.6,255,150.9,258.2,150.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.2135,
    y1: 128.8633,
    x2: 277.8622,
    y2: 128.8633,
    gradientTransform: "matrix(0.9515 0.3077 -0.3077 0.9515 55.9285 -71.2044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B2A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D2A3B"
    }
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M277.9,145.4c-4.7,2.5-16,7.1-25.6,7.5c-6.2,0.2-13.3-1.7-15.4-4.8c-2-3.2-6.7-9.8,3.8-30.9 c3.5-7,10.7-14.6,16.5-17.5c-8,2.2-14,9.2-18.6,17c-4.4,7.6-7.2,15.1-7.1,24.4c0.1,5.6,4.1,14.2,17.9,14.2 C265.6,155.1,274.8,148.1,277.9,145.4z"
  }))), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M259.2,146.5c-1.3,0-2.6,0.1-3.8,0.4c-0.6,0.1-1.6,0.2-1.5,1.1c0.1,0.8,2.8,2.6,5.6,0.1 C260.5,147.2,260.3,146.5,259.2,146.5z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M274,101.6c-0.4-0.6-3.1-1-5.2-0.9c-0.4,0-0.5,0.7-0.2,1c0.2,0.2,0.6,0.3,0.9,0.3c0.6,0.2,1.3,0.3,1.9,0.4 c0.7,0.1,1.8,0.6,2.4,0.2C274.2,102.5,274.3,102,274,101.6z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.3,101c-0.7-0.3-4.4,0.4-4.7,1.3c-0.7,1.7,2.7,1,3.4,0.9c0.7-0.1,1.5-0.2,1.8-1 C264,101.7,263.7,101.3,263.3,101z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M274.5,107.8c-0.3,0.7,0.5,1.4,0.9,1.9c0.5,0.5,1.3,1.3,2,1.3c0.7,0,1.1-0.7,1.1-1.4 C278.5,108.2,275.3,106,274.5,107.8z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.7,108.8c-2-0.8-1.2,3.2-0.6,4.5c0.4,0.8,1.2,1.5,2.1,0.9C286.2,112.9,284.4,109.5,282.7,108.8z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.1,104.6c-0.5-0.4-2.1-1.7-2.4-0.7c-0.4,1.1,1.8,2.1,2.3,2.3c0.4,0.1,0.8-0.1,0.8-0.5 C280.8,105.2,280.5,104.9,280.1,104.6z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.5,105.9c-0.7-0.8-2.3-1.2-4.2,0.1c-0.9,0.6-1.2,1.8-1,2.9c0.2,1,1.1,2.2,2.3,2.1c1.4,0,1.7-1.6,2.6-2.4 C273,107.8,273.3,106.8,272.5,105.9z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.7,106c-1-0.5-3.8-0.1-4.3,0.9c-0.7,1.8,2.1,2,3.2,1.8c0.7-0.1,1.5-0.5,1.8-1.2 C264.7,106.9,264.4,106.3,263.7,106z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.4,107.5c-2.4,0.5-3.1,2.2-2.9,3.3c0,0.2,0.3,0.3,0.5,0.2c1.4-0.6,3-1.4,3-3.1 C255,107.5,254.7,107.4,254.4,107.5z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M270.6,122.1c-0.4-0.9-1.5-1.5-2.3-0.7c-0.5,0.5-0.8,1.3-0.8,2.1c-0.3,0.8-0.4,1.8,0.3,2.5 c0.9,0.8,2,0.2,2.6-0.6C271,124.4,271.1,123.1,270.6,122.1z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266.8,118c-0.8-1.1-2.7-1-3.9,0.6c-0.2,0.3-0.3,0.8,0.1,1.1c0.5,0.3,1.4,0.1,2,0.2c0.6,0,1.2,0,1.7-0.4 C267,119,267.1,118.4,266.8,118z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M264.5,121.4c-1.8,0.4-2.4,2.8-1.7,3.8c0.4,0.6,1.4,1.1,2.1,0.5c0.7-0.6,1.1-1.8,1.1-2.7 C265.9,122.1,265.4,121.2,264.5,121.4z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259.5,112.6c-0.9-0.1-4.4,1.4-3.3,2.9c0.5,0.7,1.7,0.3,2.4,0.1c0.7-0.2,2-0.6,2.2-1.4 C261.1,113.3,260.3,112.6,259.5,112.6z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M280,116c-0.5,0.5-0.1,2,0,2.7c0.1,0.7,0.3,1.5,0.9,2c0.7,0.5,1.5-0.2,1.9-0.8 C283.5,118.6,281.6,114.3,280,116z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.4,115.3c-0.9-0.1-1.5,0.6-1.6,1.4c-0.1,0.8,0.3,1.5,0.8,2.1c0.6,1.3,1.5,2.3,2.5,1 C276.9,118.5,276.1,115.6,274.4,115.3z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.3,124.9c-0.1-0.2-0.4-0.3-0.6-0.3c-0.6,0-1,0.3-1.3,0.7c-0.1,0.1-0.3,0.3-0.4,0.4 c-0.6,0.8-1.2,2.4-0.8,3.4c0.6,1.3,2,0.6,2.6-0.3C287.7,127.6,287.9,126.2,287.3,124.9z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M281.9,134.4c-0.1-0.8-1-1.1-1.7-0.8c-0.9,0.4-1.7,1.2-2.3,1.9c-0.3,0.3-0.6,0.7-0.8,1.2 c-0.1,0.3-0.2,0.6-0.2,0.9c0.4,2.2,3.3-0.1,3.9-0.8C281.3,136.2,282,135.2,281.9,134.4z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M243.9,146.1c-0.4-1.2-1.9-3.1-3.4-2.5c-0.7,0.3-1,1.9,0.7,3.5c0.5,0.4,1.5,1,2.2,0.7 C244.1,147.5,244.1,146.7,243.9,146.1z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M248.2,144.5c-0.6-0.3-1.3-1-2.1-1c-0.6,0-1,0.6-0.8,1.1c0.1,0.4,2.4,2.8,3.4,2.5c0.6-0.2,1-0.8,0.9-1.4 C249.6,145,248.8,144.8,248.2,144.5z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247,136.3c-0.8-0.2-1.6,0.1-2.3,0.6c-0.7,0.5-1.7,1.1-1.9,2c0,0.2,0,0.3,0,0.5c0,0.4,0.1,0.8,0.5,1.2 c1.3,1.2,3.2,1,4.2-0.4C248.4,139,248.8,136.8,247,136.3z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M240.8,132.9c-0.8-0.8-1.9-0.3-2.4,0.5c-0.6,0.9-0.7,2-0.4,3c0,0.1,0,0.1,0,0.2c0.2,0.8,0.8,2.2,1.7,2.4 c1.1,0.2,1.6-1.5,1.7-2.3C241.5,135.6,241.7,133.9,240.8,132.9z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.4,140.8c-0.8,0.1-1.7,0.3-2.5,0.5c-0.4,0-0.9,0.1-1.3,0.1c-0.8,0-1.8-0.1-2.5,0.1 c-1,0.2-0.9,1.2-0.2,1.7c1.9,1.4,6.5,1,7.1-1.7C259.1,141.2,258.8,140.8,258.4,140.8z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.6,137.5c-0.3-0.4-0.9-0.6-1.4-0.3c-0.2,0.2-0.4,0.5-0.5,0.8c-0.2,0.3-0.3,0.7-0.2,1.1 c0,0.5,0.3,1,0.8,1.3c1.1,0.6,2-0.3,1.9-1.5C252.2,138.4,252,137.9,251.6,137.5z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.2,113.2c-0.5,0-1.1,0.4-1.5,0.7c-1,0.4-1.8,1.5-2,2.5c-0.1,0.6,0,1.4,0.7,1.5c0.4,0.1,0.8-0.2,1.1-0.4 c0.5-0.3,0.9-0.6,1.3-1c0.6-0.5,1.2-1,1.3-1.8C251.2,114,250.9,113.2,250.2,113.2z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M246.5,124.7c-0.6,0.2-1,0.7-1.3,1.4c-0.7,1-0.8,2.2-0.3,3.3c0.8,1.7,2.3,0.2,2.6-1 C247.8,127.5,248.2,124.2,246.5,124.7z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.9,135.6c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.6,0.1-1.2,0.3-1.8,0.6 c-0.8,0.5-1,1.6-0.2,2.1c0.9,0.6,2.3,0.2,3.2-0.2c0.8-0.4,2.1-1.2,1.9-2.2C272,134.9,270.6,135.3,269.9,135.6z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M278,124.8c-0.4,0.2-0.8,2.9-0.2,3.3c1,0.5,1.7-0.9,1.8-1.7C279.6,125.6,279,124.3,278,124.8z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.2,130.3c-0.6-0.1-2.8,0.3-2.3,2.4c0.2,1,1.9,0.4,2.5-0.2C278,132,278.4,130.5,277.2,130.3z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265,143.1c-1-0.8-2.4,0-3.2,0.7c-0.2,0.2-0.2,0.3-0.1,0.5c-0.1,1,1.7,1.3,2.4,1.1c0.5-0.1,1.1-0.4,1.3-0.9 C265.6,144,265.4,143.5,265,143.1z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M242.5,126.3c-0.4-0.7-1.3-0.6-1.8-0.1c-0.5,0.5-0.7,1.3-0.6,2c0,0.2,0.1,0.4,0.2,0.5 c0.1,0.4,0.4,0.7,0.9,0.8c0.6,0.1,1.1-0.4,1.2-1c0.1-0.4,0.1-0.9,0.1-1.3C242.7,126.9,242.7,126.6,242.5,126.3z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M250.9,130.8c-0.1-0.6-0.5-1.3-1.2-1.1c-0.5,0.1-1.6,1.8-0.7,4.1c0.2,0.6,0.7,1.1,1.3,1.1 c0.7,0,0.9-0.6,0.8-1.2C250.9,132.8,251.1,131.7,250.9,130.8z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.6,119.4c-0.5-0.2-1.2-0.2-1.8,0.1c-0.7,0.2-1.3,0.7-1.5,1.2c-0.6,1.7,1.8,1.6,2.8,1.3 c0.6-0.2,1.2-0.5,1.4-1.1C258.6,120.3,258.2,119.7,257.6,119.4z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M258.6,130.4c-0.3-0.5-0.5-1-0.8-1.4c-0.5-0.6-1.3-0.9-1.9-0.4c-0.6,0.6,0,3.5,1.9,4.3 c0.8,0.3,1.4-0.6,1.4-1.4C259,131.2,258.8,130.8,258.6,130.4z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M267.4,129.9c-0.4,0.2-2,0.9-2.3,1.2c-0.5,0.4-0.7,1.2-0.2,1.7c1.1,1,3.1,0,3.6-1.2 C268.7,131.1,269.6,129.1,267.4,129.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.6754,
    y1: 127.8248,
    x2: 268.1294,
    y2: 127.8248,
    gradientTransform: "matrix(0.9994 -3.540000e-02 3.540000e-02 0.9994 -16.9243 -11.1095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M254.1,103.7c-3.3,1.6-6.2,5.4-6.7,6.8c-0.8,2.1,2.7-1.3,3.5-2.1c1.4-1.4,2.9-2.7,4.3-4.1 C255.5,104.1,255.8,102.9,254.1,103.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.4727,
    y1: 138.9363,
    x2: 258.8332,
    y2: 138.9363,
    gradientTransform: "matrix(0.9994 -3.540000e-02 3.540000e-02 0.9994 -16.9243 -11.1095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M245.8,112.7c-2,2.5-4,5.3-5.4,8.3c-0.4,0.7-0.7,1.5-0.8,2.2c0,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.2,0,0.2 c0,0.3,0,0.6,0,0.9c0,0.2,0.3,0.3,0.4,0.1c1.2-2.1,2.3-4.3,3.6-6.4c1.1-1.8,2.4-3.4,3-5.4C246.6,112.6,246.1,112.4,245.8,112.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.8269,
    y1: 163.2469,
    x2: 291.1098,
    y2: 163.2469,
    gradientTransform: "matrix(0.9994 -3.540000e-02 3.540000e-02 0.9994 -16.9243 -11.1095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#EA5565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#EA6865"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA7665"
    }
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M279.2,139.4c-1,0.3-1.8,1-2.7,1.6c-1.1,0.5-2.3,1-3.4,1.6c-0.7,0.4-0.8,1.2,0,1.5c1.1,0.5,2.9-0.7,3.8-1.2 c1.3-0.7,2.4-1.6,2.7-3.1C279.8,139.6,279.5,139.3,279.2,139.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.6131,
    y1: 137.8299,
    x2: 255.8055,
    y2: 173.8697,
    gradientTransform: "matrix(0.9994 -3.540000e-02 3.540000e-02 0.9994 -16.9243 -11.1095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA4E65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#EA5564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3914,
    style: {
      stopColor: "#EA6863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6647,
    style: {
      stopColor: "#EA8760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#EAB25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAB75C"
    }
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M247.5,152.1c-3.4-0.5-6.9-1.6-9.6-3.9c-2.3-2-3.2-5.2-3.7-8.3c-0.2-3.8,0.8-7.9,1.7-10.9 c2.5-7.6,6.9-15.1,11.5-21.2c-4.6,3.7-11.4,16.6-13.3,25.3c-0.3,1.3-1.2,5.8-0.5,8.9c1,4.3,3.9,7.9,6.1,8.8c1.6,0.9,3.3,1.6,5,2 c8.3,1.9,19.3-0.8,26.8-4.5C268.7,149.1,255.4,153.2,247.5,152.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepperoni);
export default __webpack_public_path__ + "static/media/pepperoni.fc412d38ade31a28c0a91251b7d5aaf7.svg";
export { ForwardRef as ReactComponent };